import React from "react";
import clsx from "clsx";

import { racehorse360 } from "@tsg/1st-grpc-web-rh360";

import { useBarnsWithHorses } from "components/Location/useBarnsWithHorses";
import { mapPropsAreEqual } from "components/MapComponents/mapPropsAreEqual";

import useStyles from "./styles";

interface Props {
  containerSize: {
    width: number;
    height: number;
  };
  horses: racehorse360.IHorse[];
  mapRootRef: React.RefObject<SVGGElement>;
  clipPathRef: React.RefObject<SVGRectElement>;
  svgContainerRef: React.RefObject<HTMLDivElement>;
  handleGroupClick?: (e: React.MouseEvent) => void;
  isPreview?: boolean;
}

const GulfstreamParkMap = (props: Props) => {
  const {
    mapRootRef,
    containerSize,
    svgContainerRef,
    clipPathRef,
    handleGroupClick,
    horses,
    isPreview
  } = props;

  const stylesProps = { isPreview };
  const classes = useStyles(stylesProps);

  const barnsWithHorses = useBarnsWithHorses(horses);

  return (
    <div ref={svgContainerRef}>
      <svg
        width={containerSize.width}
        height={containerSize.height}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1848 1063"
      >
        <defs>
          <clipPath id="clip-path">
            <rect
              ref={clipPathRef}
              className={classes.cls1}
              width="1848"
              height="1063"
            />
          </clipPath>
        </defs>
        <g ref={mapRootRef}>
          <g>
            <g className={classes.cls2}>
              <polygon
                className={classes.st0}
                points="569.4,108.6 571.1,108.6 571.1,101.3 573.8,101.3 573.8,99.9 566.7,99.9 566.7,101.3 569.4,101.3
			"
              />
              <path
                className={classes.st0}
                d="M583.2,106h-1.3v2.6h0l0.6-1.8h3.4l0.6,1.8h1.9l-1.6-4.3C586.3,105.6,584.8,106,583.2,106z"
              />
              <polygon
                className={classes.st0}
                points="576.9,108.6 578.6,108.6 578.6,101.3 580.1,101.3 580.1,100.4 581.3,100.4 581.3,99.9 574.2,99.9
			574.2,101.3 576.9,101.3 		"
              />
              <path
                className={classes.st0}
                d="M584.2,102l0.7,2.1c0.2-0.2,0.2-0.5,0.2-0.8c0-1.4-1.1-1.5-2-1.5h-0.4l-0.8,2.3v0.7h1.4L584.2,102z"
              />
              <path
                className={classes.st0}
                d="M597.2,102.6v-2.3c-0.8-0.3-1.7-0.5-2.8-0.5h-2.6v0.3c1.1,0,2,0.4,2.7,1C595.7,101.3,596.7,101.6,597.2,102.6
			z"
              />
              <path
                className={classes.st0}
                d="M593.6,106.9v-4.4c-0.4-0.6-1-0.9-1.7-0.9v6.2C592.5,107.8,593.1,107.5,593.6,106.9z"
              />
              <path
                className={classes.st0}
                d="M585.1,99.9h-1.7l-0.2,0.5c0.8,0,1.5,0.1,2.2,0.3L585.1,99.9z"
              />
              <rect
                x="540.1"
                y="99.9"
                className={classes.st0}
                width="1.7"
                height="8.7"
              />
              <path
                className={classes.st0}
                d="M534.6,108.8c2.6,0,4.3-1.8,4.3-4.5s-1.7-4.5-4.3-4.5c-2.6,0-4.3,1.8-4.3,4.5S532,108.8,534.6,108.8z
			 M534.6,101.1c1.4,0,2.5,1.1,2.5,3.1c0,2.1-1.1,3.1-2.5,3.1s-2.5-1.1-2.5-3.1C532.1,102.2,533.2,101.1,534.6,101.1z"
              />
              <path
                className={classes.st0}
                d="M524.7,105.5h1.3c2,0,3.8-0.5,3.8-2.8c0-2.6-2.1-2.9-3.8-2.9h-3v8.7h1.7V105.5z M524.7,101.3h1.3
			c0.9,0,2,0.1,2,1.5c0,1.2-0.9,1.4-1.9,1.4h-1.4V101.3z"
              />
              <path
                className={classes.st0}
                d="M595.4,107.2c-0.3,0.6-0.8,1.1-1.4,1.4h0.4c1,0,2-0.1,2.8-0.5v-2.2C596.8,106.7,596.2,107,595.4,107.2z"
              />
              <polygon
                className={classes.st0}
                points="566.4,107.2 561.8,107.2 561.8,104.8 566.1,104.8 566.1,103.5 561.8,103.5 561.8,101.3 566.4,101.3
			566.4,99.9 560,99.9 560,108.6 566.4,108.6 		"
              />
              <path
                className={classes.st0}
                d="M555.5,107.4c-1,0-1.9-0.4-2.1-1.7h-1.7c0.2,1.9,1.6,3,3.7,3c1.8,0,3.5-0.9,3.5-2.7c0-1.8-1.6-2.4-3-2.6
			l-1.1-0.2c-0.7-0.1-1.2-0.5-1.2-1.1c0-0.8,0.9-1.1,1.7-1.1c0.8,0,1.7,0.3,1.8,1.4h1.7c-0.1-1.7-1.6-2.7-3.4-2.7
			c-1.6,0-3.5,0.8-3.5,2.5c0,1.5,1.2,2.2,2.6,2.5l1.1,0.2c0.9,0.2,1.6,0.5,1.6,1.2C557.3,107.1,556.3,107.4,555.5,107.4z"
              />
              <polygon
                className={classes.st0}
                points="545,102 548.4,108.6 550.7,108.6 550.7,99.9 549,99.9 549,106.5 545.6,99.9 543.3,99.9 543.3,108.6
			545,108.6 		"
              />
              <path
                className={classes.st0}
                d="M599.3,104.2c0-0.8-0.1-1.5-0.4-2.1v4.2C599.1,105.8,599.3,105.1,599.3,104.2z"
              />
              <polygon
                className={classes.st0}
                points="602.2,103.9 602.2,102.6 602.1,102.4 602.1,108.6 602.2,108.6 602.2,105.2 603.5,105.2 602.8,103.9
					"
              />
              <path
                className={classes.st0}
                d="M603.2,101.3h0.4c1.2,0,2,0.3,2,1.3c0,0.6-0.3,1.1-1,1.2l1.7,3.2v-1.3l-0.5-0.9c0.2-0.1,0.3-0.2,0.5-0.2v-4.2
			c-0.6-0.3-1.5-0.5-2.8-0.5h-2.9v0.5h2.2L603.2,101.3z"
              />
              <path
                className={classes.st1}
                d="M33.8,794.3c5.7,1.8,11.6,3.6,17.6,5.6V230.8H33.8V794.3z"
              />
              <path
                className={classes.st1}
                d="M205.8,1044.4c-1.7,0-3.1,0.9-3.1,2.4c0,1.8,1.7,2.4,3.2,2.4c1.8,0,3.2-0.9,3.2-2.5
			C209.1,1044.9,207.1,1044.4,205.8,1044.4z"
              />
              <path
                className={classes.st1}
                d="M201.6,1052.3c0,2.1,2.1,2.8,3.5,2.8c2.2,0,3.6-1.1,3.6-3c0-2.1-2-2.7-3.6-2.7
			C203,1049.4,201.6,1050.5,201.6,1052.3z"
              />
              <path
                className={classes.st1}
                d="M230.4,1044.4c-3.2,0-4.3,3.7-4.3,6.5c0,2.6,1.2,4.2,3.5,4.2c3.2,0,4.3-3.7,4.3-6.5
			C233.9,1046,232.7,1044.4,230.4,1044.4z"
              />
              <path
                className={classes.st1}
                d="M131.2,1044.6h-2.3l-2.2,10.3h3.1c4.1,0,5.9-2.8,5.9-6C135.6,1046.3,134.2,1044.6,131.2,1044.6z"
              />
              <polygon
                className={classes.st1}
                points="141.2,1051.7 146.6,1051.7 145.3,1044.8 		"
              />
              <path
                className={classes.st1}
                d="M82.5,1049.4c1.9,0,3.5-0.7,3.5-2.9c0-1.3-0.9-1.9-2.7-1.9h-1.1v4.8H82.5z"
              />
              <path
                className={classes.st1}
                d="M1815.6,1055.7h-85.5v77.8h-232.3v-144h-129.3l-54.2,45.4v-57.7H1240c-0.2,0-0.3,0-0.5,0
			c-0.1,0-5.9-0.6-12.2,0.1c-7,0.8-11.9,2.8-13.4,5.5c-1.9,3.5,0.8,10.3,7.5,18.7c0.2,0.2,0.4,0.5,0.5,0.8
			c0.3,0.5,8.9,15.2,62.2,58.8c2.1,1.8,2.4,4.9,0.7,7c-1,1.2-2.4,1.8-3.9,1.8c-1.1,0-2.2-0.4-3.2-1.1
			c-51.4-42.1-62.6-58.2-64.5-61.4c-9.6-12.2-12.3-21.9-8.2-29.4c7-12.8,31.2-11.1,35.1-10.8h74.1v-32.7h-64.3v-35.4h45.3v-19.2
			c0-37.5,32.9-32.9,32.9-32.9h40.3l34.1-34.1v-10.1c140.1-64.3,164.9-200.5,164.9-200.5h77.4v225.3h24.8v22.5h145.9v-0.4h15.1
			l-4.6-105.6c0-28.6-8.1-30.2-8.1-30.2c-12.8-10.1-12.8-22-12.8-22c6.7-25.8,26.3-6.7,26.3-6.7c0.4,0.3,0.8,0.9,1.2,1.6V670h173.8
			V-96H253.7v74.1h172.1v-42.4c0-2.8,2.2-5,5-5s5,2.2,5,5v42.4h81.4V99.6h44.2V-20.9c0-2.8,2.2-5,5-5s5,2.2,5,5V99.6h110.8V-28.5
			c-7-2.4-13.9-5-20.8-7.8c-43.8-17.9-65-35.7-65.9-36.4c-2.1-1.8-2.4-4.9-0.6-7c1.8-2.1,4.9-2.4,7-0.6c0.4,0.3,21.4,17.8,63.8,35
			c5.1,2.1,10.6,4.2,16.5,6.3v-25.1c0-2.8,2.2-5,5-5s5,2.2,5,5v28.5c40.1,13.1,97.3,25.4,171.5,25.4H1387
			c2.2-0.1,28.4-0.8,60.5,10.7c30.4,10.9,72,35.3,97.5,89.7c0,0.1,0.1,0.2,0.1,0.2c0.1,0.2,9.3,22.4,28.8,42.6
			c24.7,25.5,53.9,36.4,86.9,32.4V-64.2c0-2.8,2.2-5,5-5s5,2.2,5,5V69.3l0.1-0.1v1.9l-0.1,0.1v3.5h0.1v1.7h-0.1v4.6
			c0.1,0.4,0.1,0.9,0.1,1.4v2.6h-0.1v6.6h0.1v1.7h-0.1v1.8l0.1,0V97l-0.1,0v4.5l0.1,0v1.8l-0.1,0v3.6c0.1,0.4,0.1,0.9,0.1,1.4v2.6
			h-0.1v1.6h0.1v1.7h-0.1v0.8h0.1v5.9h-0.1v4c0.2,0.5,0.3,1,0.3,1.5c0,0.6-0.1,1.1-0.3,1.5v4h0.1v1.7h-0.1v3.9h0.1v1.7h-0.1v30.4
			c0,2.5-1.8,4.6-4.2,4.9c-6.3,1-12.5,1.5-18.6,1.5c-30.5,0-58.5-12.4-81.6-36.4c-20.1-20.9-29.7-43.3-30.5-45.4
			c-19.2-40.9-50-69.3-91.4-84.3c-20.1-7.2-37.9-9.4-48.1-10.1v196.8H842c-40.4,0-38.6-21.7-38.6-21.7v-31c0-38.7-48-26.3-48-26.3
			L687.2,134v-24.4h-170v21.3H622v89H249l-13.8,10.8h-153v579c9.3,2.9,27.8,10,50.6,26.3c29.5,21.1,72.3,62.3,108.4,138.9
			c0,0.1,0.1,0.2,0.1,0.3c0.1,0.2,8,19.1,35.9,31.8c0.6,0.3,1.3,0.6,1.9,0.8c0.4,0.1,0.8,0.2,1.3,0.4c0.4,0.2,0.7,0.4,1,0.6
			c6.2,2.5,13.6,4.8,22.2,6.5V943h143.6v-6.2h22.5v-45.7h13.9v-44.9H518v-12.4h54.7v110.3h13.9V833.8h303.5v99.9l42.6-16.3
			l15.4,25.3c0.5-0.1,0.9-0.1,1.4-0.1c0.7,0.1,18.3,2,37.6,6c24.8,5.2,40.3,11.3,47.1,18.5c0.4,0,0.7,0,1.1,0
			c15.7,0,28.5,12.8,28.5,28.5c0,15.7-12.8,28.5-28.5,28.5c-1.7,0-3.4-0.2-5-0.5l-36.6,37.2l21.1,21.4c1.9,2,1.9,5.1,0,7.1
			c-1,1-2.2,1.4-3.5,1.4c-1.3,0-2.6-0.5-3.6-1.5l-21-21.3l-47.1,48c-1,1-2.3,1.5-3.6,1.5c-1.3,0-2.5-0.5-3.5-1.4
			c-2-1.9-2-5.1-0.1-7.1l47.2-48.1l-30.7-31.1v15.3l-304.7,4.4v93.9c0,2.8-2.2,5-5,5s-5-2.2-5-5v-93.8l-330.6,4.8v-28.9
			c-11.5-2.2-22-5.5-31.5-9.9c-29.9-14-39.1-34.3-40-36.7C197.1,904.9,156,865,127.6,844.6c-19.7-14.1-36.1-21.1-45.4-24.3v214.6
			v9.4h1.1c1.9,0,3.1,0.6,3.1,2.2c0,1.5-0.8,2.7-2.6,3c1.1,0.2,2,0.8,2,2.2c0,2-1.4,3.1-3.6,3.4v40.2H51.4v-60.4V810.4
			c-6-1.9-11.9-3.8-17.6-5.6v230.1v65.1H2.9v-65.1V795.4c-27.3-8.1-45.9-12.9-46.3-13c-2.7-0.7-4.3-3.4-3.6-6.1
			c0.7-2.7,3.4-4.3,6.1-3.6c0.3,0.1,17.8,4.7,43.7,12.3V230.8H-87v946.8h2093.4v-39.9h-190.8V1055.7z M250.8,867h-35.7l12.9,23.2
			l-0.4,0.2l-0.4,0.2L214,867h-45.4v-28.8h22.1l-11.5-20.7l0.9-0.5l11.7,21.2h31.6l12.9-20.8l0.8,0.5l-12.6,20.3h26.2V867z
			 M283.6,750.5h-22.7v-11l-0.3,0.4l-16.5-10.1v1.5h-44.3v-28.8h44.3v26.2l16.8,10.2v-11.1h22.7V750.5z M93.7,1055.2h-6.5l2.3-10.9
			h0.3l-2.2,10.6h6.2L93.7,1055.2z M95.3,1055.2H95l2.3-10.9h0.3L95.3,1055.2z M106.1,1047.1c-0.4-2-1.8-2.7-3.6-2.7
			c-1.5,0-3.2,0.6-3.2,2.3c0,1.3,0.9,2,2.2,2.4l1.3,0.4c1.4,0.4,3.1,1.1,3.1,2.9c0,2-1.9,3-4,3c-2.2,0-3.9-1-4.2-3.3l0.3,0
			c0.3,2.1,1.8,3.1,3.8,3.1c1.7,0,3.7-0.7,3.7-2.7c0-1.5-1.3-2.1-2.9-2.6l-1.3-0.4c-1.3-0.4-2.5-1.1-2.5-2.7c0-1.8,1.8-2.6,3.6-2.6
			c1.9,0,3.6,0.9,3.9,3L106.1,1047.1z M115.2,1055.2h-0.3l1.2-5.5h-7.2l-1.2,5.5h-0.3l2.3-10.9h0.3l-1.1,5.1h7.2l1.1-5.1h0.3
			L115.2,1055.2z M125.3,1049.7h-6l-1.1,5.2h6.4l-0.1,0.3h-6.7l2.3-10.9h6.7l-0.1,0.3h-6.4l-1,4.8h6L125.3,1049.7z M129.8,1055.2
			h-3.5l2.3-10.9h2.5c3.2,0,4.8,1.7,4.8,4.6C136,1052.2,134.1,1055.2,129.8,1055.2z M147.2,1055.2l-0.6-3.1H141l-1.9,3.1h-0.4
			l6.5-10.9h0.3l2,10.9H147.2z M157.8,1050.8c-0.7,3.2-2,4.6-4.9,4.6c-2.4,0-3.6-0.9-3.6-3c0-0.5,0.1-1,0.2-1.6l1.4-6.5h0.3
			l-1.4,6.5c-0.1,0.6-0.2,1.1-0.2,1.5c0,1.9,1,2.8,3.3,2.8c2.7,0,4-1.4,4.6-4.3l1.4-6.5h0.3L157.8,1050.8z M169.4,1047.7
			c-0.3-2.2-1.9-3.3-4-3.3c-3.5,0-5.3,3.5-5.3,6.4c0,2.4,1.4,4.2,4,4.2c2.3,0,4.1-1.1,4.8-4.1l0.1-0.5h-3.2l0.1-0.3h3.5l-1.1,5.1
			h-0.3l0.5-2.3c-0.6,1.2-1.8,2.5-4.4,2.5c-2.7,0-4.3-1.8-4.3-4.6c0-2.9,1.8-6.7,5.7-6.7c2.2,0,4,1.2,4.3,3.6H169.4z M179.7,1050.8
			c-0.7,3.2-2,4.6-4.9,4.6c-2.4,0-3.6-0.9-3.6-3c0-0.5,0.1-1,0.2-1.6l1.4-6.5h0.3l-1.4,6.5c-0.1,0.6-0.2,1.1-0.2,1.5
			c0,1.9,1,2.8,3.3,2.8c2.7,0,4-1.4,4.6-4.3l1.4-6.5h0.3L179.7,1050.8z M189.4,1047.1c-0.4-2-1.8-2.7-3.6-2.7
			c-1.5,0-3.2,0.6-3.2,2.3c0,1.3,0.9,2,2.2,2.4l1.3,0.4c1.4,0.4,3.1,1.1,3.1,2.9c0,2-1.9,3-4,3c-2.2,0-3.9-1-4.2-3.3l0.3,0
			c0.3,2.1,1.8,3.1,3.8,3.1c1.7,0,3.7-0.7,3.7-2.7c0-1.5-1.3-2.1-2.9-2.6l-1.3-0.4c-1.3-0.4-2.5-1.1-2.5-2.7c0-1.8,1.8-2.6,3.6-2.6
			c1.9,0,3.6,0.9,3.9,3L189.4,1047.1z M198.7,1044.6h-3.9l-2.2,10.6h-0.3l2.2-10.6h-3.9l0.1-0.3h8.1L198.7,1044.6z M209,1052.1
			c0,2.1-1.7,3.3-4,3.3c-1.9,0-3.8-1-3.8-3.1c0-1.7,1.3-2.8,3.1-3c-1.3-0.4-2-1.3-2-2.4c0-1.9,1.8-2.7,3.5-2.7
			c1.7,0,3.6,0.7,3.6,2.6c0,1.5-1.2,2.4-2.6,2.7C207.8,1049.7,209,1050.4,209,1052.1z M210.7,1055.2c-0.3,1.4-0.4,1.9-1.1,2l0.1-0.3
			c0.4-0.1,0.5-0.4,0.8-1.7l0.3-1.4h0.3L210.7,1055.2z M223.3,1054.9l0,0.3h-7.5l0-0.3c5.4-3.3,8.5-5.6,8.5-8.1
			c0-1.4-1.1-2.4-2.9-2.4c-2.2,0-3.3,1.3-3.5,3.1h-0.3c0.1-1.8,1.2-3.4,3.8-3.4c2.1,0,3.2,1.2,3.2,2.7c0,2.7-3.4,5.2-8.4,8.1H223.3z
			 M229.5,1055.4c-2.5,0-3.8-1.8-3.8-4.5c0-2.9,1.2-6.8,4.7-6.8c2.5,0,3.8,1.8,3.8,4.5C234.2,1051.4,233,1055.4,229.5,1055.4z
			 M241.6,1055.2h-7.5l0-0.3c5.4-3.3,8.5-5.6,8.5-8.1c0-1.4-1.1-2.4-2.9-2.4c-2.2,0-3.3,1.3-3.5,3.1H236c0.1-1.8,1.2-3.4,3.8-3.4
			c2.1,0,3.2,1.2,3.2,2.7c0,2.7-3.4,5.2-8.4,8.1h7L241.6,1055.2z M250,1054.9l0,0.3h-7.5l0-0.3c5.4-3.3,8.5-5.6,8.5-8.1
			c0-1.4-1.1-2.4-2.9-2.4c-2.2,0-3.3,1.3-3.5,3.1h-0.3c0.1-1.8,1.2-3.4,3.8-3.4c2.1,0,3.2,1.2,3.2,2.7c0,2.7-3.4,5.2-8.4,8.1H250z
			 M754.6,821.6H409.3v-29.6h-51.7v-28.8H393l-11.5-20.7l0.9-0.5l11.7,21.2h34l6.4-22.4l1,0.3l-6.4,22.2H461v15.3h145
			c-77.1-49.1-128.3-135.4-128.3-233.6v0c0-152.9,123.9-276.8,276.8-276.8h474.9h47.1H1896v31h45.5v288h-234.6v-275l0.4-0.8h-282
			c77.1,49.1,128.3,135.4,128.3,233.6v0c0,152.9-123.9,276.8-276.8,276.8H941.3H754.6z M911,884.9v-39.5h-15.5v-17.8h20.1v6.2h51.9
			v51.1H911z M997.7,940.7h-43.4L936,913.6c50.5-24,61.7-14.5,61.7-14.5V940.7z M1031.8,937.6v-77.5h-8.2v-28.8h226.7v28.8H1240v79
			h-41.8v14.3h-16.3v-15.1H1168c0-39.5-31-39.3-31-39.3c-34.1,0-30.2,40.8-30.2,40.8h-15.5v13.5h-13.9v-15.9H1031.8z M1110.7,1121.8
			l-94.5-67.4l74.3-65l27.1,15.5l-7.7,42.6l11.6,3.1L1110.7,1121.8z M1136.9,996.3c-10.7,0-19.4-8.7-19.4-19.4V930
			c0-10.7,8.7-19.4,19.4-19.4c10.7,0,19.4,8.7,19.4,19.4v46.9C1156.3,987.6,1147.6,996.3,1136.9,996.3z M1163.4,1116.4l-10.7-107.6
			l27-19.4l85.2,76.6L1163.4,1116.4z"
              />
              <path
                className={classes.st1}
                d="M82.2,1049.7v5.2c1.9-0.2,3.2-1.1,3.2-3.1c0-1.4-0.9-2.1-2.9-2.1H82.2z"
              />
              <path
                className={classes.st1}
                d="M986.6,1053.8l33.4-34.1c-8-5-13.3-14-13.3-24.1c0-11,6.2-20.5,15.3-25.3c-14.6-8.6-50.4-15.2-73.2-17.7v65.1
			c1.3,0,2.6,0.5,3.6,1.5L986.6,1053.8z"
              />
              <path
                className={classes.st1}
                d="M1027.9,1012.6c1.7-0.6,3.7-0.2,5,1.2c0.1,0.1,0.1,0.2,0.2,0.2c0.7,0.1,1.4,0.1,2.1,0.1
			c10.2,0,18.5-8.3,18.5-18.5s-8.3-18.5-18.5-18.5s-18.5,8.3-18.5,18.5C1016.8,1003.2,1021.3,1009.8,1027.9,1012.6z M1035.2,980.9
			c8.1,0,14.7,6.6,14.7,14.7s-6.6,14.7-14.7,14.7c-8.1,0-14.7-6.6-14.7-14.7S1027.1,980.9,1035.2,980.9z"
              />
              <path
                className={classes.st1}
                d="M2.9,168.6h-37.2V-21.8H2.9v-64.7h30.8v64.7h17.6v-64.7h30.8v64.7h148l0-54.8c0-2.8,2.2-5,5-5c0,0,0,0,0,0
			V-96H-87v291.5H2.9V168.6z"
              />
              <path
                className={classes.st1}
                d="M185.6,195.6c0.3,0,0.6,0,0.9,0.1c0.2,0,16.9,2.7,29.4-8.3c5.2-4.6,8.9-10.8,11.3-18.7H82.2v26.9H185.6z"
              />
              <rect
                x="33.8"
                y="168.6"
                className={classes.st1}
                width="17.6"
                height="26.9"
              />
              <polygon points="180.2,816.9 179.3,817.4 190.8,838.1 191.9,838.1 		" />
              <polygon points="227.1,890.7 227.6,890.4 228,890.2 215.2,867 214,867 		" />
              <polygon points="237.2,817.8 236.3,817.3 223.5,838.1 224.6,838.1 		" />
              <polygon points="382.4,741.9 381.6,742.4 393,763.1 394.2,763.1 		" />
              <polygon points="435.6,740.9 434.6,740.7 428.2,763.1 429.3,763.1 		" />
              <polygon
                className={classes.st2}
                points="260.9,738.9 261.2,739 260.9,739.5 260.9,750.5 283.6,750.5 283.6,727.8 260.9,727.8 		"
              />
              <path
                className={classes.st3}
                d="M948.9,952.7c22.8,2.5,58.6,9.1,73.2,17.7c-9.1,4.8-15.3,14.3-15.3,25.3c0,10.1,5.3,19,13.3,24.1l-33.4,34.1
			l-34.1-34.6c-1-1-2.3-1.5-3.6-1.5v12.1l30.7,31.1l-47.2,48.1c-1.9,2-1.9,5.1,0.1,7.1c1,1,2.2,1.4,3.5,1.4c1.3,0,2.6-0.5,3.6-1.5
			l47.1-48l21,21.3c1,1,2.3,1.5,3.6,1.5c1.3,0,2.5-0.5,3.5-1.4c2-1.9,2-5.1,0-7.1l-21.1-21.4l36.6-37.2c1.6,0.3,3.3,0.5,5,0.5
			c15.7,0,28.5-12.8,28.5-28.5c0-15.7-12.8-28.5-28.5-28.5c-0.4,0-0.7,0-1.1,0c-6.8-7.3-22.3-13.3-47.1-18.5
			c-19.3-4-36.8-5.9-37.6-6c-0.5-0.1-0.9,0-1.4,0.1l0.9,1.4V952.7z M1035.2,977.2c10.2,0,18.5,8.3,18.5,18.5s-8.3,18.5-18.5,18.5
			c-0.7,0-1.4-0.1-2.1-0.1c-0.1-0.1-0.1-0.2-0.2-0.2c-1.4-1.3-3.3-1.7-5-1.2c-6.5-2.8-11.1-9.4-11.1-16.9
			C1016.8,985.5,1025,977.2,1035.2,977.2z"
              />
              <path
                className={classes.st4}
                d="M1156.3,930c0-10.7-8.7-19.4-19.4-19.4c-10.7,0-19.4,8.7-19.4,19.4v46.9c0,10.7,8.7,19.4,19.4,19.4
			c10.7,0,19.4-8.7,19.4-19.4V930z"
              />
              <path
                className={classes.st5}
                d="M440.7,1001.7c0.1,0,0.1,0,0.2-0.1c0.8-0.2,83.9-21,198.9-7.1c2.5,0.3,4.4,2.4,4.4,5v50.1l304.7-4.4v-15.3
			v-12.1v-65.1v-8.5l-0.9-1.4l-15.4-25.3l-42.6,16.3v-99.9H586.6v110.3h-13.9V833.8H518v12.4h-34.3v44.9h-13.9v45.7h-22.5v6.2H303.6
			v72.4C332.8,1021.3,376.6,1020.8,440.7,1001.7z"
              />
              <path
                className={classes.st5}
                d="M443.5,1011.3c-40.1,12-76,17.8-106.8,17.5c-11.8-0.1-22.8-1.2-33.1-3.1v28.9l330.6-4.8V1004
			C525.2,991.5,446.6,1010.6,443.5,1011.3z"
              />
              <polygon
                className={classes.st6}
                points="967.5,833.8 915.6,833.8 915.6,827.7 895.5,827.7 895.5,845.5 911,845.5 911,884.9 967.5,884.9 		"
              />
              <path
                className={classes.st6}
                d="M1077.4,953.5h13.9v-13.5h15.5c0,0-3.9-40.8,30.2-40.8c0,0,31-0.2,31,39.3h13.9v15.1h16.3v-14.3h41.8v-79
			h-208.3v77.5h45.7V953.5z"
              />
              <polygon
                className={classes.st6}
                points="1117.7,1004.9 1090.6,989.5 1016.3,1054.5 1110.7,1121.8 1121.6,1050.6 1109.9,1047.5 		"
              />
              <polygon
                className={classes.st6}
                points="1152.6,1008.8 1163.4,1116.4 1264.8,1066.1 1179.6,989.5 		"
              />
              <polygon
                className={classes.st7}
                points="1707.2,311.1 1706.8,311.9 1706.8,586.9 1941.4,586.9 1941.4,298.9 1896,298.9 1896,311.1 		"
              />
              <path
                className={classes.st7}
                d="M2006.5,670h-173.8v16.7c13.8,26.6,18.2,322.8,18.2,322.8l21.7,31c10.1,24-10.1,24.4-10.1,24.4h-24.8
			c-30.2-1.9,0-54.6,0-54.6l-7-160.7h-15.1v0.4h0.4v205.5h-0.4v82h190.8h38.1l5.7-13V958h11.3l5.7-13V670H2006.5z"
              />
              <path
                className={classes.st7}
                d="M1387.3-0.4c-0.1,0-0.1,0-0.2,0H863.8C819-0.4,755.5-5,692.2-25.2v129.8c0,2.8-2.2,5-5,5V134l68.1-16.3
			c0,0,48-12.4,48,26.3v31c0,0-1.7,21.7,38.6,21.7h554.4V-0.2C1390.7-0.5,1387.4-0.4,1387.3-0.4z"
              />
              <path
                className={classes.st7}
                d="M235.2-81.6c2.8,0,5,2.2,5,5l0,54.8h13.5V-96h-18.4L235.2-81.6C235.2-81.6,235.2-81.6,235.2-81.6z"
              />
              <path
                className={classes.st7}
                d="M237.5,168.6c-2.9,11.1-7.9,19.9-15.2,26.3c-10.7,9.4-23.3,11-30.9,11c-3,0-5.3-0.3-6.2-0.4h-103v25.2h153
			l13.8-10.8h373v-89H517.2v37.7H237.5z"
              />
              <rect
                x="-87"
                y="205.6"
                className={classes.st7}
                width="89.9"
                height="25.2"
              />
              <rect
                x="33.8"
                y="205.6"
                className={classes.st7}
                width="17.6"
                height="25.2"
              />
              <path
                className={classes.st7}
                d="M936,913.6l18.4,27.1h43.4v-41.6C997.7,899.1,986.5,889.6,936,913.6z"
              />
              <path
                className={classes.st7}
                d="M1035.2,1010.4c8.1,0,14.7-6.6,14.7-14.7s-6.6-14.7-14.7-14.7c-8.1,0-14.7,6.6-14.7,14.7
			S1027.1,1010.4,1035.2,1010.4z"
              />
              <path
                className={classes.st4}
                d="M1831.5,685.2c0,0-19.6-19.2-26.3,6.7c0,0,0,11.9,12.8,22c0,0,8.1,1.5,8.1,30.2l4.6,105.6l7,160.7
			c0,0-30.2,52.6,0,54.6h24.8c0,0,20.1-0.4,10.1-24.4l-21.7-31c0,0-4.4-296.2-18.2-322.8C1832.3,686.1,1831.9,685.5,1831.5,685.2z"
              />
              <path
                className={classes.st3}
                d="M638.4,1071.1c-1.4,0-1.5,1.1-1.5,2v1.3h3v-1.4C639.8,1072,639.5,1071.1,638.4,1071.1z"
              />
              <polygon
                className={classes.st3}
                points="641,1067.3 641,1064.9 637.6,1066.1 		"
              />
              <path
                className={classes.st3}
                d="M-40.8,772.7c-2.7-0.7-5.4,0.9-6.1,3.6c-0.7,2.7,0.9,5.4,3.6,6.1c0.3,0.1,19,5,46.3,13V785
			C-23,777.3-40.5,772.8-40.8,772.7z"
              />
              <path
                className={classes.st3}
                d="M638.1,1056.1c-1,0-1.3,0.8-1.3,2v1.3h2.6v-1.4C639.4,1056.7,639,1056.1,638.1,1056.1z"
              />
              <path
                className={classes.st3}
                d="M33.8,794.3v10.5c5.7,1.8,11.6,3.7,17.6,5.6v-10.5C45.4,797.9,39.5,796.1,33.8,794.3z"
              />
              <path
                className={classes.st3}
                d="M127.6,844.6c28.4,20.4,69.5,60.3,104.5,134.5c1,2.3,10.1,22.7,40,36.7c9.4,4.4,20,7.7,31.5,9.9
			c10.3,1.9,21.3,3,33.1,3.1c30.8,0.4,66.7-5.5,106.8-17.5c3.1-0.8,81.7-19.8,190.7-7.3v45.8v93.8c0,2.8,2.2,5,5,5s5-2.2,5-5v-93.9
			v-50.1c0-2.5-1.9-4.7-4.4-5c-115-13.9-198.1,6.9-198.9,7.1c-0.1,0-0.1,0-0.2,0.1c-64.2,19.1-108,19.5-137.2,13.7
			c-8.7-1.7-16-4-22.2-6.5c1.2,0.9,1.6,2.2,1.3,3.5l-1.5-0.7c0.1-1-0.5-1.8-1.3-2.1c-1.3-0.6-2.7-0.1-3.5,1.8
			c-0.8,1.9-0.4,3.3,1,3.9c0.8,0.4,2.2,0.4,2.7-0.8l0.1-0.1l-2-0.9l0.6-1.3l3.4,1.5l-1.8,4.2l-1.2-0.5l0.4-1c-0.7,0.5-1.7,0.5-2.9,0
			c-2.2-1-2.9-3.2-1.8-5.8c0.9-2,2.5-3,4.4-2.7c-0.6-0.3-1.3-0.6-1.9-0.8c-27.9-12.7-35.8-31.7-35.9-31.8c0-0.1-0.1-0.2-0.1-0.3
			c-36.1-76.6-78.8-117.8-108.4-138.9c-22.8-16.3-41.3-23.5-50.6-26.3v10.6C91.5,823.5,107.9,830.5,127.6,844.6z M635.5,1009.1h1.4
			v4.6h2.2v-4.4h1.4v4.4h2.4v-4.6h1.4v6.3h-8.7V1009.1z M635.5,1022.1l6.6-3.5h-6.6v-1.6h8.7v2.2l-6.6,3.5h6.6v1.6h-8.7V1022.1z
			 M635.5,1028.4l8.7-3.2v1.9l-1.8,0.6v3.4l1.8,0.6v1.8l-8.7-3.2V1028.4z M635.5,1037.7h7.3v-4.2h1.4v5.9h-8.7V1037.7z
			 M635.5,1051.3h4l-4-3.5v-2l3.5,3.2l5.2-3.4v2l-3.9,2.6l1.3,1.2h2.6v1.7h-8.7V1051.3z M635.5,1058.3c0-2.9,0.8-4,2.6-4
			c1,0,1.8,0.5,2.3,1.6l3.8-1.9v1.9l-3.4,1.7v0.4v1.4h3.4v1.7h-8.7V1058.3z M635.5,1065.2l8.7-3.2v1.9l-1.8,0.6v3.4l1.8,0.6v1.8
			l-8.7-3.2V1065.2z M635.5,1073.2c0-1.8,0.2-3.8,2.9-3.8c2.2,0,2.8,1.8,2.8,3.8v1.3h3.1v1.7h-8.7V1073.2z M373.4,1016.8l2.5,3.3
			l1.6-3.9l1.9-0.3l-2.5,5.7l0.5,3.3l-1.7,0.2l-0.5-3.4l-3.8-4.8L373.4,1016.8z M368,1017.4l1.7-0.2l4.2,8.3l-1.8,0.2l-0.8-1.7
			l-3.4,0.4l-0.4,1.8l-1.7,0.2L368,1017.4z M356.8,1018.5l1.8,6.2l0.7-6.4l2-0.2l1.9,6.2l0.6-6.5l1.7-0.1l-1.2,8.8l-2,0.2l-1.9-6.3
			l-0.8,6.6l-2,0.2l-2.7-8.5L356.8,1018.5z M345.3,1019l2.3,6.7l1.8-6.8l2.5-0.1l0.3,8.7l-1.6,0.1l-0.2-6.5l-1.9,6.6l-1.7,0.1
			l-2.4-6.5l0.2,6.5l-1.6,0.1l-0.3-8.7L345.3,1019z M339.2,1019.1l3.2,8.7l-1.9,0l-0.6-1.8l-3.4,0l-0.6,1.8l-1.8,0l3.3-8.7
			L339.2,1019.1z M328,1018.8l6.3,0.3l-0.1,1.4l-4.6-0.2l-0.1,2.2l4.4,0.2l-0.1,1.4l-4.4-0.2l-0.1,2.4l4.6,0.2l-0.1,1.4l-6.3-0.3
			L328,1018.8z M320.2,1018.2l2.8,0.2c2.9,0.2,3.9,1.1,3.7,2.9c-0.1,1-0.6,1.8-1.8,2.2l1.6,3.9l-1.9-0.2l-1.4-3.5l-0.4,0l-1.4-0.1
			l-0.3,3.4l-1.7-0.1L320.2,1018.2z M312.5,1017.3l7,0.9l-0.2,1.4l-2.7-0.3l-0.9,7.3l-1.7-0.2l0.9-7.3l-2.7-0.3L312.5,1017.3z
			 M309,1016.5c1.8,0.3,3.1,1.6,2.9,3.3l-1.6-0.3c0-1-0.8-1.5-1.6-1.6c-0.8-0.1-1.7,0-1.8,0.8c-0.1,0.6,0.3,1,1,1.3l1.1,0.4
			c1.4,0.5,2.8,1.3,2.5,3.1c-0.3,1.8-2.2,2.3-3.9,2c-2.1-0.4-3.3-1.7-3.2-3.6l1.6,0.3c0,1.3,0.8,1.8,1.8,2c0.8,0.1,1.8,0,1.9-0.9
			c0.1-0.7-0.5-1.1-1.4-1.4l-1.1-0.4c-1.3-0.5-2.4-1.4-2.1-2.9C305.4,1016.7,307.4,1016.3,309,1016.5z M299,1014.7l6.2,1.4l-0.3,1.4
			l-4.5-1l-0.5,2.1l4.3,0.9l-0.3,1.4l-4.3-0.9l-0.8,3.7l-1.7-0.4L299,1014.7z M294.4,1013.4l-2,7l4.1,1.1l-0.4,1.3l-5.7-1.6l2.3-8.4
			L294.4,1013.4z M283.1,1015l1.6-4.7l1.6,0.6l-1.6,4.8c-0.5,1.5-0.5,2.4,1,2.9c1.5,0.5,2.1-0.3,2.6-1.7l1.6-4.8l1.6,0.6l-1.6,4.7
			c-0.9,2.7-2.2,3.3-4.6,2.5C282.9,1019,282.2,1017.8,283.1,1015z"
              />
              <polygon
                className={classes.st3}
                points="369.1,1019.4 368.3,1023 370.7,1022.7 		"
              />
              <polygon
                className={classes.st3}
                points="641,1030.5 641,1028.1 637.6,1029.3 		"
              />
              <polygon
                className={classes.st3}
                points="338.3,1021.2 337.1,1024.6 339.5,1024.6 		"
              />
              <path
                className={classes.st3}
                d="M325,1021.3c0.1-1-0.7-1.4-1.9-1.5l-1.3-0.1l-0.2,2.6l1.4,0.1C324.4,1022.5,325,1022.1,325,1021.3z"
              />
              <path
                className={classes.st3}
                d="M528,102.8c0-1.4-1.1-1.5-2-1.5h-1.3v3h1.4C527.2,104.2,528,103.9,528,102.8z"
              />
              <path
                className={classes.st3}
                d="M583.3,104.7L583.3,104.7c0.7,0,1.3-0.1,1.7-0.6l-0.7-2.1L583.3,104.7z"
              />
              <polygon
                className={classes.st3}
                points="602.8,103.9 602.2,102.6 602.2,103.9 		"
              />
              <path
                className={classes.st3}
                d="M605.5,102.6c0-1-0.8-1.3-2-1.3h-0.4l1.3,2.5C605.2,103.6,605.5,103.2,605.5,102.6z"
              />
              <path
                className={classes.st3}
                d="M594.2,104.7c0-0.9-0.2-1.7-0.6-2.2v4.4C594,106.4,594.2,105.7,594.2,104.7z"
              />
              <path
                className={classes.st3}
                d="M597.2,105.9v-3.2c-0.5-1.1-1.5-1.3-2.6-1.4c0.9,0.8,1.4,2,1.4,3.5c0,0.9-0.2,1.8-0.6,2.5
			C596.2,107,596.8,106.7,597.2,105.9z"
              />
              <path
                className={classes.st3}
                d="M534.6,107.4c1.4,0,2.5-1.1,2.5-3.1c0-2-1.1-3.1-2.5-3.1s-2.5,1.1-2.5,3.1
			C532.1,106.3,533.2,107.4,534.6,107.4z"
              />
              <path
                className={classes.st3}
                d="M662.7,103c0-1-0.8-1.3-2-1.3h-1.3v2.6h1.4C662.1,104.3,662.7,103.9,662.7,103z"
              />
              <path
                className={classes.st3}
                d="M654.6,104.7c0-2.6-1.6-3-3.1-3h-0.8v6h0.8C653.1,107.7,654.6,107.3,654.6,104.7z"
              />
              <polygon
                className={classes.st3}
                points="641.3,102.5 640.1,105.9 642.5,105.9 		"
              />
              <path
                className={classes.st3}
                d="M606.2,105.7v-1.1c-0.1,0.1-0.3,0.2-0.5,0.2L606.2,105.7z"
              />
              <path
                className={classes.st3}
                d="M591.7,107.9c0,0,0.1,0,0.1,0v-6.2c0,0-0.1,0-0.1,0c-1.4,0-2.5,1.1-2.5,3.1
			C589.2,106.8,590.4,107.9,591.7,107.9z"
              />
              <polygon
                className={classes.st3}
                points="581.9,101.7 581.9,104 582.7,101.7 		"
              />
              <polygon
                className={classes.st3}
                points="1667.7,98.1 1664.3,99.3 1667.7,100.5 		"
              />
              <path
                className={classes.st3}
                d="M1666.6,123.9c-2,0-3.1,1.1-3.1,2.5s1.1,2.5,3.1,2.5c2.1,0,3.1-1.1,3.1-2.5S1668.6,123.9,1666.6,123.9z"
              />
              <rect
                x="1667.2"
                y="133.6"
                className={classes.st3}
                width="3.7"
                height="3.9"
              />
              <polygon
                className={classes.st3}
                points="1667.5,73.3 1667.5,74.7 1670.8,74.7 1670.8,71.2 1667.5,72.9 		"
              />
              <path
                className={classes.st3}
                d="M1666.6,79.4c-2.6,0-3,1.6-3,3.1v0.8h6v-0.8C1669.6,81,1669.2,79.4,1666.6,79.4z"
              />
              <path
                className={classes.st3}
                d="M1664.9,71.4c-1,0-1.3,0.8-1.3,2v1.3h2.6v-1.4C1666.2,72,1665.7,71.4,1664.9,71.4z"
              />
              <polygon
                className={classes.st3}
                points="1669.2,101 1670.8,101.6 1670.8,97.1 1669.2,97.7 		"
              />
              <path
                className={classes.st3}
                d="M1666.6,105.3c-2.6,0-3,1.6-3,3.1v0.8h6v-0.8C1669.6,106.9,1669.2,105.3,1666.6,105.3z"
              />
              <path
                className={classes.st3}
                d="M1314.3,967.2h-74.1c-3.9-0.4-28.1-2-35.1,10.8c-4.1,7.5-1.4,17.2,8.2,29.4c1.9,3.2,13.1,19.3,64.5,61.4
			c0.9,0.8,2.1,1.1,3.2,1.1c1.4,0,2.9-0.6,3.9-1.8c1.8-2.1,1.4-5.3-0.7-7c-53.3-43.7-61.9-58.3-62.2-58.8c-0.1-0.3-0.3-0.5-0.5-0.8
			c-6.7-8.4-9.4-15.2-7.5-18.7c1.5-2.7,6.4-4.7,13.4-5.5c6.3-0.7,12.1-0.1,12.2-0.1c0.2,0,0.3,0,0.5,0h74.3v-8.6V967.2z"
              />
              <path
                className={classes.st5}
                d="M1669.7,827.7h-24.8V602.4h-77.4c0,0-24.8,136.3-164.9,200.5v10.1l-34.1,34.1h-40.3c0,0-32.9-4.6-32.9,32.9
			v19.2h-45.3v35.4h64.3v32.7v1.4v8.6v57.7l54.2-45.4h129.3v144h232.3v-77.8h85.5h0.4V850.1h-0.4h-145.9V827.7z"
              />
              <path
                className={classes.st8}
                d="M1276.6,821.6c152.9,0,276.8-123.9,276.8-276.8v0c0-98.2-51.2-184.5-128.3-233.6h282H1896v-12.2v-31h-619.4
			h-47.1H754.6c-152.9,0-276.8,123.9-276.8,276.8v0c0,98.2,51.2,184.5,128.3,233.6H461v13.6h-51.7v29.6h345.3h186.7H1276.6z
			 M524.9,544.7L524.9,544.7c0-128.6,104.2-232.8,232.8-232.8h519.1c128.6,0,232.8,104.2,232.8,232.8v0
			c0,128.6-104.2,232.8-232.8,232.8H757.7C629.1,777.5,524.9,673.3,524.9,544.7z"
              />
              <path
                className={classes.st9}
                d="M1509.5,544.7L1509.5,544.7c0-128.6-104.2-232.8-232.8-232.8H757.7c-128.6,0-232.8,104.2-232.8,232.8v0
			c0,128.6,104.2,232.8,232.8,232.8h519.1C1405.3,777.5,1509.5,673.3,1509.5,544.7z M1154.5,653.3c0-30.8-41.8-27.2-41.8-27.2
			c-81.3,0-102.8,27.9-102.8,27.9c-17.9,15.8-39.5,22.3-56,24.9H752.5c-72,0-130.5-58.4-130.5-130.5v-7.3
			c0-72,58.4-130.5,130.5-130.5h526.1c72,0,130.5,58.4,130.5,130.5v7.3c0,72-58.4,130.5-130.5,130.5h-93.2
			C1153.7,673.1,1154.5,653.3,1154.5,653.3z"
              />
              <path
                className={classes.st4}
                d="M1409.1,548.4v-7.3c0-72-58.4-130.5-130.5-130.5H752.5c-72,0-130.5,58.4-130.5,130.5v7.3
			c0,72,58.4,130.5,130.5,130.5h201.5c16.5-2.6,38-9.1,56-24.9c0,0,21.5-27.9,102.8-27.9c0,0,41.8-3.6,41.8,27.2
			c0,0-0.8,19.8,30.9,25.6h93.2C1350.7,678.8,1409.1,620.4,1409.1,548.4z"
              />
              <path
                className={classes.st10}
                d="M274.7,1010.7c-1.1,2.6-0.4,4.8,1.8,5.8c1.1,0.5,2.1,0.4,2.9,0l-0.4,1l1.2,0.5l1.8-4.2l-3.4-1.5l-0.6,1.3
			l2,0.9l-0.1,0.1c-0.6,1.3-1.9,1.2-2.7,0.8c-1.4-0.6-1.8-2-1-3.9c0.8-1.9,2.2-2.4,3.5-1.8c0.9,0.4,1.5,1.2,1.3,2.1l1.5,0.7
			c0.3-1.3-0.2-2.6-1.3-3.5c-0.3-0.2-0.6-0.4-1-0.6c-0.4-0.2-0.9-0.3-1.3-0.4C277.2,1007.7,275.6,1008.7,274.7,1010.7z"
              />
              <path
                className={classes.st10}
                d="M285.3,1019.9c2.4,0.8,3.7,0.2,4.6-2.5l1.6-4.7l-1.6-0.6l-1.6,4.8c-0.5,1.5-1.1,2.2-2.6,1.7
			c-1.5-0.5-1.5-1.5-1-2.9l1.6-4.8l-1.6-0.6l-1.6,4.7C282.2,1017.8,282.9,1019,285.3,1019.9z"
              />
              <polygon
                className={classes.st10}
                points="296.1,1023 296.5,1021.6 292.4,1020.5 294.4,1013.4 292.7,1013 290.4,1021.4 		"
              />
              <polygon
                className={classes.st10}
                points="299.6,1019.9 303.9,1020.8 304.2,1019.5 299.9,1018.5 300.4,1016.4 304.9,1017.4 305.2,1016.1
			299,1014.7 297.1,1023.2 298.8,1023.6 		"
              />
              <path
                className={classes.st10}
                d="M307.3,1021.4l1.1,0.4c0.9,0.3,1.5,0.7,1.4,1.4c-0.2,0.9-1.2,1-1.9,0.9c-1-0.2-1.8-0.7-1.8-2l-1.6-0.3
			c-0.2,1.9,1,3.2,3.2,3.6c1.7,0.3,3.6-0.3,3.9-2c0.3-1.8-1.1-2.6-2.5-3.1l-1.1-0.4c-0.7-0.2-1.1-0.7-1-1.3c0.1-0.8,1-0.9,1.8-0.8
			c0.8,0.1,1.6,0.6,1.6,1.6l1.6,0.3c0.2-1.7-1.2-3-2.9-3.3c-1.6-0.3-3.5,0.2-3.8,1.9C304.9,1019.9,306,1020.9,307.3,1021.4z"
              />
              <polygon
                className={classes.st10}
                points="314.1,1026.2 315.8,1026.5 316.7,1019.2 319.3,1019.5 319.5,1018.1 312.5,1017.3 312.3,1018.7
			315,1019 		"
              />
              <path
                className={classes.st10}
                d="M321.5,1023.6l1.4,0.1l0.4,0l1.4,3.5l1.9,0.2l-1.6-3.9c1.1-0.4,1.7-1.2,1.8-2.2c0.1-1.8-0.9-2.7-3.7-2.9
			l-2.8-0.2l-0.7,8.7l1.7,0.1L321.5,1023.6z M321.8,1019.7l1.3,0.1c1.2,0.1,2,0.5,1.9,1.5c-0.1,0.9-0.7,1.3-2,1.2l-1.4-0.1
			L321.8,1019.7z"
              />
              <polygon
                className={classes.st10}
                points="334.1,1026.4 329.4,1026.2 329.5,1023.8 333.9,1024 334,1022.6 329.6,1022.4 329.7,1020.3
			334.3,1020.5 334.4,1019.1 328,1018.8 327.7,1027.5 334,1027.8 		"
              />
              <path
                className={classes.st10}
                d="M335.9,1027.8l0.6-1.8l3.4,0l0.6,1.8l1.9,0l-3.2-8.7l-1.7,0l-3.3,8.7L335.9,1027.8z M338.3,1021.2l1.2,3.4
			l-2.4,0L338.3,1021.2z"
              />
              <polygon
                className={classes.st10}
                points="344.7,1027.8 344.5,1021.2 346.9,1027.7 348.6,1027.6 350.5,1021 350.7,1027.5 352.3,1027.5
			352,1018.8 349.5,1018.9 347.7,1025.7 345.3,1019 342.8,1019.1 343.1,1027.8 		"
              />
              <polygon
                className={classes.st10}
                points="359.7,1027 360.5,1020.4 362.4,1026.7 364.4,1026.6 365.6,1017.7 363.8,1017.9 363.2,1024.3
			361.3,1018.1 359.3,1018.3 358.6,1024.7 356.8,1018.5 355.1,1018.6 357.7,1027.1 		"
              />
              <path
                className={classes.st10}
                d="M368,1024.4l3.4-0.4l0.8,1.7l1.8-0.2l-4.2-8.3l-1.7,0.2l-2.2,9l1.7-0.2L368,1024.4z M369.1,1019.4l1.6,3.3
			l-2.4,0.3L369.1,1019.4z"
              />
              <polygon
                className={classes.st10}
                points="375.7,1025.2 377.4,1025 377,1021.7 379.4,1016 377.5,1016.2 375.9,1020.1 373.4,1016.8 371.5,1017
			375.3,1021.9 		"
              />
              <path
                className={classes.st10}
                d="M644.2,1074.4h-3.1v-1.3c0-2-0.5-3.8-2.8-3.8c-2.6,0-2.9,2.1-2.9,3.8v3h8.7V1074.4z M639.8,1074.4h-3v-1.3
			c0-0.9,0.1-2,1.5-2c1.2,0,1.4,0.9,1.4,1.9V1074.4z"
              />
              <path
                className={classes.st10}
                d="M644.2,1068.4l-1.8-0.6v-3.4l1.8-0.6v-1.9l-8.7,3.2v1.7l8.7,3.2V1068.4z M641,1067.3l-3.4-1.2l3.4-1.2
			V1067.3z"
              />
              <path
                className={classes.st10}
                d="M644.2,1059.4h-3.4v-1.4v-0.4l3.4-1.7v-1.9l-3.8,1.9c-0.5-1.1-1.3-1.6-2.3-1.6c-1.8,0-2.6,1.1-2.6,4v2.9h8.7
			V1059.4z M639.4,1059.4h-2.6v-1.3c0-1.2,0.3-2,1.3-2c0.9,0,1.3,0.6,1.3,1.9V1059.4z"
              />
              <polygon
                className={classes.st10}
                points="644.2,1051.3 641.6,1051.3 640.2,1050.1 644.2,1047.6 644.2,1045.5 639,1049 635.5,1045.8
			635.5,1047.8 639.5,1051.3 635.5,1051.3 635.5,1053 644.2,1053 		"
              />
              <polygon
                className={classes.st10}
                points="644.2,1033.5 642.8,1033.5 642.8,1037.7 635.5,1037.7 635.5,1039.4 644.2,1039.4 		"
              />
              <path
                className={classes.st10}
                d="M644.2,1031.6l-1.8-0.6v-3.4l1.8-0.6v-1.9l-8.7,3.2v1.7l8.7,3.2V1031.6z M641,1030.5l-3.4-1.2l3.4-1.2
			V1030.5z"
              />
              <polygon
                className={classes.st10}
                points="644.2,1022.7 637.5,1022.7 644.2,1019.3 644.2,1017 635.5,1017 635.5,1018.7 642.1,1018.7
			635.5,1022.1 635.5,1024.4 644.2,1024.4 		"
              />
              <polygon
                className={classes.st10}
                points="644.2,1009.1 642.8,1009.1 642.8,1013.8 640.4,1013.8 640.4,1009.4 639,1009.4 639,1013.8
			636.9,1013.8 636.9,1009.1 635.5,1009.1 635.5,1015.5 644.2,1015.5 		"
              />
              <rect
                x="33.8"
                y="195.6"
                className={classes.st3}
                width="17.6"
                height="10"
              />
              <polygon
                className={classes.st3}
                points="82.8,142.4 85.8,142.4 84.3,138.1 		"
              />
              <path
                className={classes.st3}
                d="M240.2-76.6c0-2.8-2.2-5-5-5c0,0,0,0,0,0s0,0,0,0c-2.8,0-5,2.2-5,5l0,54.8h-148H51.4H33.8H2.9h-37.2v190.5
			H2.9h30.8h17.6h30.8h144.9c-2.4,7.9-6.2,14.2-11.3,18.7c-12.4,11-29.2,8.3-29.4,8.3c-0.3-0.1-0.6-0.1-0.9-0.1H82.2v10h103
			c1,0.1,3.2,0.4,6.2,0.4c7.6,0,20.2-1.6,30.9-11c7.3-6.4,12.4-15.2,15.2-26.3h279.7v-37.7v-21.3h170c2.8,0,5-2.2,5-5V-25.2
			C755.5-5,819-0.4,863.8-0.4h523.4c0.1,0,0.1,0,0.2,0c0.1,0,3.4-0.1,9.1,0.2c10.2,0.6,28.1,2.8,48.1,10.1
			c41.4,15,72.2,43.3,91.4,84.3c0.9,2.1,10.4,24.5,30.5,45.4c23.1,24,51,36.4,81.6,36.4c6.1,0,12.3-0.5,18.6-1.5
			c2.4-0.4,4.2-2.5,4.2-4.9v-30.4h-8.6v-1.7h3.5v-3.9h-3.5v-1.7h8.6v-4c-0.6,1.7-2.1,2.7-4.3,2.7c-2.7,0-4.5-1.7-4.5-4.3
			c0-2.6,1.8-4.3,4.5-4.3c2.1,0,3.7,1,4.3,2.7v-4h-8.6v-1.7h7.3V115h1.3v-0.8h-8.6v-1.7h8.6v-1.6h-8.6v-2.6c0-2.8,0.9-4.8,4.3-4.8
			c2.8,0,3.9,1.4,4.3,3.4v-3.6l-8.6-3.2v-1.7l8.6-3.2v-1.8h-3.3l-5.3,3.1v-2l3.6-2l-3.6-2.1v-2l5.3,3.2h3.3v-6.6h-8.6v-2.6
			c0-2.8,0.9-4.8,4.3-4.8c2.8,0,3.9,1.4,4.3,3.4v-4.6h-8.6v-2.9c0-2.9,0.8-4,2.6-4c1,0,1.8,0.5,2.3,1.6l3.7-1.9V-64.2
			c0-2.8-2.2-5-5-5s-5,2.2-5,5v229.5c-33.1,4-62.3-6.9-86.9-32.4c-19.5-20.2-28.7-42.4-28.8-42.6c0-0.1-0.1-0.2-0.1-0.2
			c-25.5-54.3-67.1-78.8-97.5-89.7c-32.1-11.5-58.3-10.8-60.5-10.7H863.8c-74.2,0-131.5-12.3-171.5-25.4v-28.5c0-2.8-2.2-5-5-5
			s-5,2.2-5,5v25.1c-5.9-2.1-11.5-4.2-16.5-6.3c-42.4-17.2-63.4-34.7-63.8-35c-2.1-1.8-5.3-1.5-7,0.6c-1.8,2.1-1.5,5.3,0.6,7
			c0.9,0.7,22.1,18.5,65.9,36.4c6.9,2.8,13.9,5.4,20.8,7.8V99.6H571.5V-20.9c0-2.8-2.2-5-5-5s-5,2.2-5,5V99.6h-44.2V-21.8h-81.4
			v-42.4c0-2.8-2.2-5-5-5s-5,2.2-5,5v42.4H253.7h-13.5L240.2-76.6z M97.1,205.1c-2.1,0-3.6-1.2-3.7-3h1.7c0.2,1.3,1.1,1.7,2.1,1.7
			c0.8,0,1.7-0.3,1.7-1.2c0-0.7-0.7-1-1.6-1.2l-1.1-0.2c-1.4-0.3-2.6-1-2.6-2.5c0-1.8,1.9-2.5,3.5-2.5c1.8,0,3.3,1.1,3.4,2.7h-1.7
			c-0.1-1-1-1.4-1.8-1.4c-0.8,0-1.7,0.3-1.7,1.1c0,0.6,0.5,0.9,1.2,1.1l1.1,0.2c1.4,0.3,3,0.8,3,2.6
			C100.7,204.2,98.9,205.1,97.1,205.1z M108.1,197.7h-4.6v2.2h4.4v1.4h-4.4v2.4h4.6v1.4h-6.3v-8.7h6.3V197.7z M114.6,205h-1.7v-6.5
			h-1.9v-1.1c1.2,0,1.9-0.1,2.3-1.1h1.3V205z M123,202.9h-1.5v2.1h-1.6v-2.1h-4.3v-1.3l4.3-5.3h1.6v5.2h1.5V202.9z M127.1,199.6
			h-1.3v3.3c0,0.7,0.2,0.8,0.8,0.8h0.5v1.2h-1.2c-1.5,0-1.8-0.5-1.8-1.7v-3.6h-0.9v-1.1h0.9v-1.8h1.7v1.8h1.3V199.6z M133.9,205
			h-1.7v-3.7c0-0.8-0.2-1.6-1.1-1.6c-1.1,0-1.3,0.9-1.3,1.9v3.4h-1.7v-8.7h1.7v3.1c0.4-0.7,1.1-1,1.9-1c1.6,0,2.2,0.9,2.2,2.5V205z
			 M143.6,205l-0.6-1.8h-3.4L139,205h-1.8l3.2-8.7h1.7l3.2,8.7H143.6z M149.4,205h-1.8l-3-8.7h1.9l2.1,6.5l2-6.5h1.8L149.4,205z
			 M159.5,197.7h-4.6v2.2h4.4v1.4h-4.4v2.4h4.6v1.4h-6.3v-8.7h6.3V197.7z M657.6,100.4h2.9c2.9,0,4,0.8,4,2.6c0,1-0.5,1.8-1.6,2.3
			l1.9,3.8h-1.9l-1.7-3.4h-0.4h-1.4v3.4h-1.7V100.4z M649,100.4h2.6c2.8,0,4.8,0.9,4.8,4.3s-2.1,4.4-4.8,4.4H649V100.4z
			 M642.3,100.4l3.2,8.7h-1.9l-0.6-1.8h-3.4l-0.6,1.8h-1.8l3.2-8.7H642.3z M631.4,100.4h7.1v1.4h-2.7v7.3H634v-7.3h-2.7V100.4z
			 M623.9,100.4h7.1v1.4h-2.7v7.3h-1.7v-7.3h-2.7V100.4z M617.2,100.4h6.3v1.4h-4.6v2.2h4.4v1.4h-4.4v2.4h4.6v1.4h-6.3V100.4z
			 M612.8,105.5l-1.1-0.2c-1.4-0.3-2.6-1-2.6-2.5c0-1.8,1.9-2.5,3.5-2.5c1.8,0,3.3,1.1,3.4,2.7h-1.7c-0.1-1-1-1.4-1.8-1.4
			c-0.8,0-1.7,0.3-1.7,1.1c0,0.6,0.5,0.9,1.2,1.1l1.1,0.2c1.4,0.3,3,0.8,3,2.6c0,1.8-1.8,2.7-3.5,2.7c-2.1,0-3.5-1.2-3.7-3h1.7
			c0.2,1.3,1.1,1.7,2.1,1.7c0.8,0,1.7-0.3,1.7-1.2C614.4,105.9,613.7,105.6,612.8,105.5z M600.5,100.4L600.5,100.4l0-0.5h2.9
			c1.3,0,2.2,0.2,2.8,0.5v-0.1h1.6v8.7h-2.2l-2-3.9h-1.3v3.4h-0.1v0.5h-1.6V100.4z M591.7,100.2c0,0,0.1,0,0.1,0v-0.3h2.6
			c1,0,2,0.1,2.8,0.5v0h1.7v1.8c0.2,0.6,0.4,1.3,0.4,2.1s-0.1,1.5-0.4,2.1v2.7h-1.7v-0.9c-0.8,0.3-1.7,0.5-2.8,0.5H594
			c-0.6,0.4-1.4,0.6-2.3,0.6c-2.6,0-4.3-1.8-4.3-4.5S589.1,100.2,591.7,100.2z M574.2,99.9h7.1v0.5h1.8c0,0,0.1,0,0.1,0l0.2-0.5h1.7
			l0.3,0.8c0.9,0.4,1.5,1.1,1.5,2.5c0,0.4-0.1,0.8-0.2,1.1l1.6,4.3h-1.9l-0.6-1.8h-3.4l-0.6,1.8h0v0.5h-1.7v-7.8h-1.5v7.3h-1.7v-7.3
			h-2.7V99.9z M566.7,99.9h7.1v1.4h-2.7v7.3h-1.7v-7.3h-2.7V99.9z M560,99.9h6.3v1.4h-4.6v2.2h4.4v1.4h-4.4v2.4h4.6v1.4H560V99.9z
			 M555.6,105l-1.1-0.2c-1.4-0.3-2.6-1-2.6-2.5c0-1.8,1.9-2.5,3.5-2.5c1.8,0,3.3,1.1,3.4,2.7h-1.7c-0.1-1-1-1.4-1.8-1.4
			c-0.8,0-1.7,0.3-1.7,1.1c0,0.6,0.5,0.9,1.2,1.1l1.1,0.2c1.4,0.3,3,0.8,3,2.6c0,1.8-1.8,2.7-3.5,2.7c-2.1,0-3.5-1.2-3.7-3h1.7
			c0.2,1.3,1.1,1.7,2.1,1.7c0.8,0,1.7-0.3,1.7-1.2C557.3,105.4,556.6,105.1,555.6,105z M543.3,99.9h2.2l3.5,6.6v-6.6h1.6v8.7h-2.2
			L545,102v6.6h-1.6V99.9z M540.1,99.9h1.7v8.7h-1.7V99.9z M534.6,99.8c2.6,0,4.3,1.8,4.3,4.5s-1.7,4.5-4.3,4.5
			c-2.6,0-4.3-1.8-4.3-4.5S532,99.8,534.6,99.8z M523,99.9h3c1.8,0,3.8,0.2,3.8,2.9c0,2.2-1.8,2.8-3.8,2.8h-1.3v3.1H523V99.9z
			 M67.2,146.5c-2.7,0-4.4-1.4-4.6-3.8h2.1c0.2,1.6,1.3,2.1,2.6,2.1c1,0,2.2-0.4,2.2-1.5c0-0.9-0.9-1.3-2-1.5l-1.4-0.3
			c-1.8-0.4-3.3-1.3-3.3-3.1c0-2.2,2.3-3.1,4.3-3.1c2.2,0,4.2,1.3,4.3,3.4h-2.1c-0.2-1.3-1.3-1.7-2.3-1.7c-1,0-2.1,0.4-2.1,1.3
			c0,0.8,0.6,1.2,1.5,1.4l1.4,0.3c1.8,0.3,3.7,1,3.7,3.3C71.6,145.4,69.4,146.5,67.2,146.5z M77.3,146.3h-2.1v-9.1h-3.3v-1.7h8.8
			v1.7h-3.4V146.3z M87.2,146.3l-0.8-2.2h-4.2l-0.8,2.2h-2.2l4.1-10.9h2.2l4.1,10.9H87.2z M94.9,146.3h-4.4v-10.9h4.2
			c1.9,0,4,0.6,4,2.8c0,1-0.7,1.9-1.2,2.3c0.8,0.4,1.6,1,1.6,2.5C99.1,145.5,97.2,146.3,94.9,146.3z M107.9,146.3h-7.4v-10.9h2.1
			v9.1h5.3V146.3z M116.8,137.2H111v2.7h5.5v1.7H111v3h5.8v1.7h-7.9v-10.9h7.9V137.2z M133,146.3h-2v-8.2l-2.7,8.2h-2.1l-2.7-8.2
			v8.2h-2v-10.9h3.1l2.6,8.5l2.6-8.5h3.1V146.3z M141.8,146.3l-0.8-2.2h-4.2l-0.8,2.2h-2.2l4-10.9h2.2l4.1,10.9H141.8z M148.9,142.5
			h-1.6v3.8h-2.1v-10.9h3.7c2.2,0,4.8,0.3,4.8,3.6C153.6,141.8,151.4,142.5,148.9,142.5z M485.6,140.7H157.9v-0.5h327.7V140.7z
			 M485.6,38.6v87.1H61.3V38.6H485.6z"
              />
              <path
                className={classes.st3}
                d="M94.9,141.6h-2.3v3.1H95c1.2,0,1.9-0.5,1.9-1.5S96.3,141.6,94.9,141.6z"
              />
              <polygon
                className={classes.st3}
                points="137.4,142.4 140.4,142.4 138.9,138.1 		"
              />
              <path
                className={classes.st3}
                d="M96.5,138.5c0-0.9-0.6-1.4-1.6-1.4h-2.2v2.8h2.2C95.9,139.9,96.5,139.5,96.5,138.5z"
              />
              <path
                className={classes.st3}
                d="M148.8,137.1h-1.6v3.7h1.8c1.3,0,2.4-0.3,2.4-1.8C151.4,137.3,150,137.1,148.8,137.1z"
              />
              <polygon
                className={classes.st3}
                points="140.1,201.8 142.5,201.8 141.3,198.4 		"
              />
              <polygon
                className={classes.st3}
                points="119.9,201.5 119.9,198.4 117.4,201.5 		"
              />
              <path
                className={classes.st3}
                d="M2.9,195.6H-87h-29.4c-2.8,0-5,2.2-5,5s2.2,5,5,5H-87H2.9V195.6z"
              />
              <polygon
                className={classes.st11}
                points="33.8,230.8 33.8,205.6 33.8,195.6 33.8,168.6 2.9,168.6 2.9,195.6 2.9,205.6 2.9,230.8 2.9,785
			2.9,795.4 2.9,1034.9 2.9,1100 33.8,1100 33.8,1034.9 33.8,804.8 33.8,794.3 		"
              />
              <rect
                x="2.9"
                y="-86.5"
                className={classes.st11}
                width="30.8"
                height="64.7"
              />
              <polygon
                className={classes.st11}
                points="65.5,490.9 72.1,488.6 65.5,486.3 		"
              />
              <path
                className={classes.st11}
                d="M64.4,540.1c1.6,0,2.4-1,2.4-3v-3.5H62v3.6C62,539.2,62.8,540.1,64.4,540.1z"
              />
              <path
                className={classes.st11}
                d="M67.8,477.1c5,0,5.7-3,5.7-6v-1.5H62v1.5C62,474.2,62.7,477.1,67.8,477.1z"
              />
              <path
                className={classes.st11}
                d="M71.4,539.5c1.3,0,2.1-0.9,2.1-2.5v-3.4h-4.3v3.4C69.2,538.6,70,539.5,71.4,539.5z"
              />
              <path
                className={classes.st11}
                d="M62,620.5c0,1.9,0.8,2.9,2.3,2.9s2.4-1,2.4-3v-3.5H62V620.5z"
              />
              <polygon
                className={classes.st11}
                points="65.5,568.4 72.1,566.1 65.5,563.8 		"
              />
              <polygon
                className={classes.st11}
                points="65.5,400.3 72.1,398 65.5,395.7 		"
              />
              <path
                className={classes.st11}
                d="M67.8,664.8c5,0,5.7-3,5.7-6v-1.5H62v1.5C62,661.8,62.7,664.8,67.8,664.8z"
              />
              <polygon
                className={classes.st11}
                points="65.5,442.1 72.1,439.8 65.5,437.5 		"
              />
              <path
                className={classes.st11}
                d="M69.2,620.2c0,1.6,0.7,2.5,2.2,2.5c1.3,0,2.1-0.9,2.1-2.5v-3.4h-4.3V620.2z"
              />
              <rect
                x="51.4"
                y="-86.5"
                className={classes.st11}
                width="30.8"
                height="64.7"
              />
              <path
                className={classes.st11}
                d="M82.2,195.6v-26.9H51.4v26.9v10v25.2v569.1v10.5v224.5v60.4h30.8v-40.2c-0.3,0-0.6,0-0.9,0h-3.9l2.3-10.9
			h2.5v-9.4V820.3v-10.6v-579v-25.2V195.6z M59.4,350.3h16.7v12.1h-2.7v-8.9h-4.1v8.4h-2.7v-8.4h-4.5v8.9h-2.7V350.3z M59.4,385.7
			h7.2v-7.5h-7.2v-3.3h16.7v3.3h-6.8v7.5h6.8v3.3H59.4V385.7z M59.4,402.4l3.4-1.2v-6.5l-3.4-1.2v-3.4l16.7,6.2v3.3L59.4,406V402.4z
			 M59.4,407.5h16.7v3.3h-14v8.1h-2.7V407.5z M59.4,420.4h16.7v3.3h-14v8.1h-2.7V420.4z M59.4,444.2l3.4-1.2v-6.5l-3.4-1.2V432
			l16.7,6.2v3.3l-16.7,6.2V444.2z M59.4,459.1l12.7-6.7H59.4v-3.1h16.7v4.3l-12.7,6.7h12.7v3.1H59.4V459.1z M59.4,466.3h16.7v4.9
			c0,5.3-1.7,9.3-8.3,9.3c-6.6,0-8.3-4-8.3-9.3V466.3z M59.4,493l3.4-1.2v-6.5l-3.4-1.2v-3.4l16.7,6.2v3.3l-16.7,6.2V493z
			 M59.4,498.1h16.7v3.3h-14v8.1h-2.7V498.1z M59.4,511h16.7v12.1h-2.7v-8.9h-4.1v8.4h-2.7v-8.4h-4.5v8.9h-2.7V511z M59.4,530.3
			h16.7v6.5c0,2.9-0.9,6.1-4.3,6.1c-1.6,0-3-1-3.5-1.9c-0.6,1.3-1.6,2.5-3.9,2.5c-3.6,0-4.9-3-4.9-6.4V530.3z M59.4,545.6h16.7v12.1
			h-2.7v-8.9h-4.1v8.4h-2.7v-8.4h-4.5v8.9h-2.7V545.6z M59.4,570.5l3.4-1.2v-6.5l-3.4-1.2v-3.4l16.7,6.2v3.3l-16.7,6.2V570.5z
			 M67.8,574.2c5.3,0,8.6,3,8.6,7.9c0,3.9-2.2,6.6-5.7,7.1v-3.1c2.3-0.6,3.1-2.2,3.1-4c0-2.5-2.1-4.5-5.9-4.5c-4,0-6.1,2-6.1,4.3
			c0,2,0.9,3.6,3.2,4.1v3.1c-3.4-0.4-5.8-3.2-5.8-7.2C59.1,577,62.5,574.2,67.8,574.2z M76.1,602.1v3.3H59.4v-3.3h7.2v-7.5h-7.2
			v-3.3h16.7v3.3h-6.8v7.5H76.1z M76.1,649.1v3.5l-16.7-5.7v-3.4l16.7-5.8v3.6l-12.6,4L76.1,649.1z M76.1,654v4.9
			c0,5.3-1.7,9.3-8.3,9.3c-6.6,0-8.3-4-8.3-9.3V654H76.1z M62.1,632.1v8.1h-2.7v-11.4h16.7v3.3H62.1z M71.8,626.1
			c-1.6,0-3-1-3.5-1.9c-0.6,1.3-1.6,2.5-3.9,2.5c-3.6,0-4.9-3-4.9-6.4v-6.8h16.7v6.5C76.1,622.9,75.2,626.1,71.8,626.1z
			 M62.2,1050.4h-2.6l-1,4.8h-0.3l2.3-10.9h2.8c2.3,0,3.9,0.6,3.9,2.4C67.3,1049.6,65,1050.4,62.2,1050.4z M76,1050.8
			c-0.7,3.2-2,4.6-4.9,4.6c-2.4,0-3.6-0.9-3.6-3c0-0.5,0.1-1,0.2-1.6l1.4-6.5h0.3l-1.4,6.5c-0.1,0.6-0.2,1.1-0.2,1.5
			c0,1.9,1,2.8,3.3,2.8c2.7,0,4-1.4,4.6-4.3l1.4-6.5h0.3L76,1050.8z"
              />
              <path
                className={classes.st11}
                d="M63.4,1044.6h-2.6l-1.2,5.5h2.5c2.3,0,4.8-0.5,4.8-3.4C67,1045,65.5,1044.6,63.4,1044.6z"
              />
              <polygon
                className={classes.st11}
                points="82.2,1049.4 82.2,1044.6 80,1044.6 79,1049.4 		"
              />
              <path
                className={classes.st11}
                d="M78.9,1049.7l-1.1,5.2h3.5c0.3,0,0.6,0,0.9,0v-5.2H78.9z"
              />
              <polygon
                className={classes.st10}
                points="62.1,353.6 66.6,353.6 66.6,362 69.3,362 69.3,353.6 73.4,353.6 73.4,362.5 76.1,362.5 76.1,350.3
			59.4,350.3 59.4,362.5 62.1,362.5 		"
              />
              <polygon
                className={classes.st10}
                points="76.1,385.7 69.3,385.7 69.3,378.2 76.1,378.2 76.1,374.9 59.4,374.9 59.4,378.2 66.6,378.2
			66.6,385.7 59.4,385.7 59.4,389 76.1,389 		"
              />
              <path
                className={classes.st10}
                d="M76.1,396.5l-16.7-6.2v3.4l3.4,1.2v6.5l-3.4,1.2v3.6l16.7-6.2V396.5z M65.5,400.3v-4.6l6.6,2.3L65.5,400.3z"
              />
              <polygon
                className={classes.st10}
                points="62.1,410.8 76.1,410.8 76.1,407.5 59.4,407.5 59.4,418.9 62.1,418.9 		"
              />
              <polygon
                className={classes.st10}
                points="62.1,423.7 76.1,423.7 76.1,420.4 59.4,420.4 59.4,431.8 62.1,431.8 		"
              />
              <path
                className={classes.st10}
                d="M76.1,438.3L59.4,432v3.4l3.4,1.2v6.5l-3.4,1.2v3.6l16.7-6.2V438.3z M65.5,442.1v-4.6l6.6,2.3L65.5,442.1z"
              />
              <polygon
                className={classes.st10}
                points="76.1,460.2 63.4,460.2 76.1,453.6 76.1,449.3 59.4,449.3 59.4,452.4 72.1,452.4 59.4,459.1
			59.4,463.3 76.1,463.3 		"
              />
              <path
                className={classes.st10}
                d="M67.8,480.5c6.6,0,8.3-4,8.3-9.3v-4.9H59.4v4.9C59.4,476.6,61.2,480.5,67.8,480.5z M62,469.6h11.5v1.5
			c0,3-0.8,6-5.7,6c-5,0-5.8-3-5.8-6V469.6z"
              />
              <path
                className={classes.st10}
                d="M76.1,487l-16.7-6.2v3.4l3.4,1.2v6.5l-3.4,1.2v3.6l16.7-6.2V487z M65.5,490.9v-4.6l6.6,2.3L65.5,490.9z"
              />
              <polygon
                className={classes.st10}
                points="62.1,501.3 76.1,501.3 76.1,498.1 59.4,498.1 59.4,509.5 62.1,509.5 		"
              />
              <polygon
                className={classes.st10}
                points="62.1,514.2 66.6,514.2 66.6,522.6 69.3,522.6 69.3,514.2 73.4,514.2 73.4,523.1 76.1,523.1
			76.1,511 59.4,511 59.4,523.1 62.1,523.1 		"
              />
              <path
                className={classes.st10}
                d="M64.4,543.5c2.3,0,3.3-1.2,3.9-2.5c0.6,0.9,2,1.9,3.5,1.9c3.4,0,4.3-3.2,4.3-6.1v-6.5H59.4v6.8
			C59.4,540.5,60.8,543.5,64.4,543.5z M69.2,533.6h4.3v3.4c0,1.5-0.8,2.5-2.1,2.5c-1.5,0-2.2-0.9-2.2-2.5V533.6z M62,533.6h4.7v3.5
			c0,2-0.8,3-2.4,3s-2.3-1-2.3-2.9V533.6z"
              />
              <polygon
                className={classes.st10}
                points="62.1,548.9 66.6,548.9 66.6,557.3 69.3,557.3 69.3,548.9 73.4,548.9 73.4,557.8 76.1,557.8
			76.1,545.6 59.4,545.6 59.4,557.8 62.1,557.8 		"
              />
              <path
                className={classes.st10}
                d="M76.1,564.5l-16.7-6.2v3.4l3.4,1.2v6.5l-3.4,1.2v3.6l16.7-6.2V564.5z M65.5,568.4v-4.6l6.6,2.3L65.5,568.4z"
              />
              <path
                className={classes.st10}
                d="M64.9,589.2v-3.1c-2.3-0.6-3.2-2.1-3.2-4.1c0-2.4,2.1-4.3,6.1-4.3c3.9,0,5.9,2,5.9,4.5c0,1.8-0.8,3.4-3.1,4
			v3.1c3.5-0.6,5.7-3.2,5.7-7.1c0-4.9-3.3-7.9-8.6-7.9c-5.3,0-8.7,2.8-8.7,7.8C59.1,586,61.5,588.8,64.9,589.2z"
              />
              <polygon
                className={classes.st10}
                points="76.1,594.6 76.1,591.3 59.4,591.3 59.4,594.6 66.6,594.6 66.6,602.1 59.4,602.1 59.4,605.3
			76.1,605.3 76.1,602.1 69.3,602.1 69.3,594.6 		"
              />
              <path
                className={classes.st10}
                d="M76.1,613.5H59.4v6.8c0,3.4,1.3,6.4,4.9,6.4c2.3,0,3.3-1.2,3.9-2.5c0.6,0.9,2,1.9,3.5,1.9
			c3.4,0,4.3-3.2,4.3-6.1V613.5z M66.7,620.3c0,2-0.8,3-2.4,3s-2.3-1-2.3-2.9v-3.6h4.7V620.3z M73.5,620.2c0,1.5-0.8,2.5-2.1,2.5
			c-1.5,0-2.2-0.9-2.2-2.5v-3.4h4.3V620.2z"
              />
              <polygon
                className={classes.st10}
                points="76.1,628.8 59.4,628.8 59.4,640.2 62.1,640.2 62.1,632.1 76.1,632.1 		"
              />
              <polygon
                className={classes.st10}
                points="76.1,637.7 59.4,643.5 59.4,646.9 76.1,652.6 76.1,649.1 63.5,645.2 76.1,641.3 		"
              />
              <path
                className={classes.st10}
                d="M59.4,658.9c0,5.3,1.7,9.3,8.3,9.3c6.6,0,8.3-4,8.3-9.3V654H59.4V658.9z M62,657.3h11.5v1.5c0,3-0.8,6-5.7,6
			c-5,0-5.8-3-5.8-6V657.3z"
              />
              <path
                className={classes.st10}
                d="M97.7,199.8l-1.1-0.2c-0.7-0.1-1.2-0.5-1.2-1.1c0-0.8,0.9-1.1,1.7-1.1c0.8,0,1.7,0.3,1.8,1.4h1.7
			c-0.1-1.7-1.6-2.7-3.4-2.7c-1.6,0-3.5,0.8-3.5,2.5c0,1.5,1.2,2.2,2.6,2.5l1.1,0.2c0.9,0.2,1.6,0.5,1.6,1.2c0,0.9-1,1.2-1.7,1.2
			c-1,0-1.9-0.4-2.1-1.7h-1.7c0.2,1.9,1.6,3,3.7,3c1.8,0,3.5-0.9,3.5-2.7C100.7,200.6,99.1,200.1,97.7,199.8z"
              />
              <polygon
                className={classes.st10}
                points="101.7,205 108.1,205 108.1,203.6 103.5,203.6 103.5,201.2 107.8,201.2 107.8,199.8 103.5,199.8
			103.5,197.7 108.1,197.7 108.1,196.3 101.7,196.3 		"
              />
              <path
                className={classes.st10}
                d="M111.1,197.3v1.1h1.9v6.5h1.7v-8.7h-1.3C112.9,197.2,112.3,197.3,111.1,197.3z"
              />
              <path
                className={classes.st10}
                d="M121.5,196.3h-1.6l-4.3,5.3v1.3h4.3v2.1h1.6v-2.1h1.5v-1.4h-1.5V196.3z M119.9,201.5h-2.5l2.5-3.1V201.5z"
              />
              <path
                className={classes.st10}
                d="M125.7,196.8h-1.7v1.8h-0.9v1.1h0.9v3.6c0,1.3,0.3,1.7,1.8,1.7h1.2v-1.2h-0.5c-0.6,0-0.8-0.1-0.8-0.8v-3.3
			h1.3v-1.1h-1.3V196.8z"
              />
              <path
                className={classes.st10}
                d="M131.7,198.4c-0.8,0-1.5,0.3-1.9,1v-3.1h-1.7v8.7h1.7v-3.4c0-1,0.2-1.9,1.3-1.9c0.9,0,1.1,0.7,1.1,1.6v3.7
			h1.7v-4.1C133.9,199.3,133.2,198.4,131.7,198.4z"
              />
              <path
                className={classes.st10}
                d="M140.5,196.3l-3.2,8.7h1.8l0.6-1.8h3.4l0.6,1.8h1.9l-3.2-8.7H140.5z M140.1,201.8l1.2-3.4l1.2,3.4H140.1z"
              />
              <polygon
                className={classes.st10}
                points="148.6,202.8 146.5,196.3 144.6,196.3 147.6,205 149.4,205 152.4,196.3 150.6,196.3 		"
              />
              <polygon
                className={classes.st10}
                points="153.1,205 159.5,205 159.5,203.6 154.8,203.6 154.8,201.2 159.2,201.2 159.2,199.8 154.8,199.8
			154.8,197.7 159.5,197.7 159.5,196.3 153.1,196.3 		"
              />
              <path
                className={classes.st10}
                d="M580.1,101.3v7.8h1.7v-0.5V106h1.3c1.6,0,3.1-0.4,3.6-1.7c0.1-0.3,0.2-0.6,0.2-1.1c0-1.5-0.7-2.2-1.5-2.5
			c-0.7-0.3-1.4-0.3-2.2-0.3c0,0-0.1,0-0.1,0h-1.8h-1.1V101.3z M581.9,104v-2.3h0.8h0.4c0.9,0,2,0.1,2,1.5c0,0.4-0.1,0.6-0.2,0.8
			c-0.3,0.4-0.9,0.6-1.7,0.6h0h-1.4V104z"
              />
              <path
                className={classes.st10}
                d="M591.7,109.2c0.9,0,1.7-0.2,2.3-0.6c0.6-0.3,1-0.8,1.4-1.4c0.4-0.7,0.6-1.5,0.6-2.5c0-1.5-0.5-2.7-1.4-3.5
			c-0.7-0.6-1.6-1-2.7-1c0,0-0.1,0-0.1,0c-2.6,0-4.3,1.8-4.3,4.5S589.1,109.2,591.7,109.2z M591.7,101.6c0,0,0.1,0,0.1,0
			c0.7,0,1.3,0.4,1.7,0.9c0.4,0.5,0.6,1.2,0.6,2.2c0,0.9-0.2,1.7-0.6,2.2c-0.4,0.6-1,0.9-1.7,0.9c0,0-0.1,0-0.1,0
			c-1.4,0-2.5-1.1-2.5-3.1C589.2,102.7,590.4,101.6,591.7,101.6z"
              />
              <polygon
                className={classes.st10}
                points="597.2,105.9 597.2,108.1 597.2,109.1 598.9,109.1 598.9,106.4 598.9,102.1 598.9,100.4 597.2,100.4
			597.2,100.4 597.2,102.6 		"
              />
              <polygon
                className={classes.st10}
                points="602.1,108.6 602.1,102.4 602.2,102.6 602.8,103.9 603.5,105.2 605.6,109.1 607.8,109.1 607.8,100.4
			606.2,100.4 606.2,100.4 606.2,104.6 606.2,105.7 606.2,107 604.5,103.8 603.2,101.3 602.7,100.4 600.5,100.4 600.5,100.4
			600.5,109.1 602.1,109.1 		"
              />
              <path
                className={classes.st10}
                d="M612.7,107.9c-1,0-1.9-0.4-2.1-1.7h-1.7c0.2,1.9,1.6,3,3.7,3c1.8,0,3.5-0.9,3.5-2.7c0-1.8-1.6-2.4-3-2.6
			l-1.1-0.2c-0.7-0.1-1.2-0.5-1.2-1.1c0-0.8,0.9-1.1,1.7-1.1c0.8,0,1.7,0.3,1.8,1.4h1.7c-0.1-1.7-1.6-2.7-3.4-2.7
			c-1.6,0-3.5,0.8-3.5,2.5c0,1.5,1.2,2.2,2.6,2.5l1.1,0.2c0.9,0.2,1.6,0.5,1.6,1.2C614.4,107.6,613.4,107.9,612.7,107.9z"
              />
              <polygon
                className={classes.st10}
                points="623.5,107.7 618.9,107.7 618.9,105.3 623.3,105.3 623.3,103.9 618.9,103.9 618.9,101.8 623.5,101.8
			623.5,100.4 617.2,100.4 617.2,109.1 623.5,109.1 		"
              />
              <polygon
                className={classes.st10}
                points="626.5,109.1 628.3,109.1 628.3,101.8 630.9,101.8 630.9,100.4 623.9,100.4 623.9,101.8 626.5,101.8
					"
              />
              <polygon
                className={classes.st10}
                points="634,109.1 635.7,109.1 635.7,101.8 638.4,101.8 638.4,100.4 631.4,100.4 631.4,101.8 634,101.8
			"
              />
              <path
                className={classes.st10}
                d="M639,109.1l0.6-1.8h3.4l0.6,1.8h1.9l-3.2-8.7h-1.7l-3.2,8.7H639z M641.3,102.5l1.2,3.4h-2.4L641.3,102.5z"
              />
              <path
                className={classes.st10}
                d="M656.4,104.7c0-3.5-2.1-4.3-4.8-4.3H649v8.7h2.6C654.3,109.1,656.4,108.2,656.4,104.7z M650.7,107.7v-6h0.8
			c1.6,0,3.1,0.4,3.1,3c0,2.6-1.6,3-3.1,3H650.7z"
              />
              <path
                className={classes.st10}
                d="M659.3,105.7h1.4h0.4l1.7,3.4h1.9l-1.9-3.8c1.1-0.5,1.6-1.3,1.6-2.3c0-1.8-1.1-2.6-4-2.6h-2.9v8.7h1.7V105.7
			z M659.3,101.7h1.3c1.2,0,2,0.3,2,1.3c0,0.9-0.6,1.3-1.9,1.3h-1.4V101.7z"
              />
              <polygon
                className={classes.st10}
                points="1662.2,133.6 1665.8,133.6 1665.8,137.5 1662.2,137.5 1662.2,139.2 1670.8,139.2 1670.9,139.2
			1670.9,137.5 1670.8,137.5 1667.2,137.5 1667.2,133.6 1670.8,133.6 1670.9,133.6 1670.9,131.9 1670.8,131.9 1662.2,131.9 		"
              />
              <path
                className={classes.st10}
                d="M1666.6,122.2c-2.7,0-4.5,1.7-4.5,4.3c0,2.6,1.8,4.3,4.5,4.3c2.1,0,3.7-1,4.3-2.7c0.2-0.5,0.3-1,0.3-1.5
			c0-0.6-0.1-1.1-0.3-1.5C1670.2,123.2,1668.7,122.2,1666.6,122.2z M1666.6,128.9c-2,0-3.1-1.1-3.1-2.5s1.1-2.5,3.1-2.5
			c2.1,0,3.1,1.1,3.1,2.5S1668.6,128.9,1666.6,128.9z"
              />
              <polygon
                className={classes.st10}
                points="1669.5,119.2 1662.2,119.2 1662.2,121 1670.8,121 1670.9,121 1670.9,115 1670.8,115 1669.5,115
			"
              />
              <polygon
                className={classes.st10}
                points="1662.2,114.2 1670.8,114.2 1670.9,114.2 1670.9,112.5 1670.8,112.5 1662.2,112.5 		"
              />
              <path
                className={classes.st10}
                d="M1666.6,103.5c-3.5,0-4.3,2.1-4.3,4.8v2.6h8.6h0.1v-2.6c0-0.5,0-1-0.1-1.4
			C1670.5,104.9,1669.4,103.5,1666.6,103.5z M1669.6,109.2h-6v-0.8c0-1.6,0.4-3.1,3-3.1c2.6,0,3,1.6,3,3.1V109.2z"
              />
              <path
                className={classes.st10}
                d="M1662.2,100.2l8.6,3.2l0.1,0v-1.8l-0.1,0l-1.7-0.6v-3.4l1.7-0.6l0.1,0v-1.9l-0.1,0l-8.6,3.2V100.2z
			 M1667.7,98.1v2.4l-3.4-1.2L1667.7,98.1z"
              />
              <polygon
                className={classes.st10}
                points="1662.2,88.5 1662.2,90.4 1665.9,92.5 1662.2,94.5 1662.2,96.5 1667.5,93.4 1670.8,93.4 1670.9,93.4
			1670.9,91.7 1670.8,91.7 1667.6,91.7 		"
              />
              <path
                className={classes.st10}
                d="M1666.6,77.7c-3.5,0-4.3,2.1-4.3,4.8v2.6h8.6h0.1v-2.6c0-0.5,0-1-0.1-1.4
			C1670.5,79.1,1669.4,77.7,1666.6,77.7z M1669.6,83.4h-6v-0.8c0-1.6,0.4-3.1,3-3.1c2.6,0,3,1.6,3,3.1V83.4z"
              />
              <path
                className={classes.st10}
                d="M1664.9,69.6c-1.8,0-2.6,1.1-2.6,4v2.9h8.6h0.1v-1.7h-0.1h-3.3v-1.4v-0.4l3.3-1.7l0.1-0.1v-1.9l-0.1,0.1
			l-3.7,1.9C1666.7,70.1,1665.9,69.6,1664.9,69.6z M1666.2,74.7h-2.6v-1.3c0-1.2,0.3-2,1.3-2c0.9,0,1.3,0.6,1.3,1.9V74.7z"
              />
              <polygon points="260.9,738.9 244.1,728.6 244.1,729.8 260.7,739.9 260.9,739.5 261.2,739 		" />
              <path
                className={classes.st12}
                d="M244.1,702.5h-44.3v28.8h44.3v-1.5v-1.2V702.5z M213.3,722.4H211l-4-11.6h2.5l2.8,8.7l2.7-8.7h2.4
			L213.3,722.4z M226.7,712.7h-6.2v2.9h5.8v1.9h-5.8v3.2h6.2v1.9h-8.5v-11.6h8.5V712.7z M236.6,712.7H233v9.7h-2.3v-9.7h-3.6v-1.9
			h9.4V712.7z"
              />
              <polygon points="212.2,719.6 209.4,710.8 206.9,710.8 211,722.4 213.3,722.4 217.3,710.8 214.9,710.8 		" />
              <polygon
                points="218.3,722.4 226.7,722.4 226.7,720.6 220.6,720.6 220.6,717.4 226.4,717.4 226.4,715.6 220.6,715.6 220.6,712.7
			226.7,712.7 226.7,710.8 218.3,710.8 		"
              />
              <polygon points="227.2,712.7 230.8,712.7 230.8,722.4 233,722.4 233,712.7 236.6,712.7 236.6,710.8 227.2,710.8 		" />
              <path
                className={classes.st12}
                d="M371.9,773.2h-1.8v3.5h1.9c1.8,0,2.6-0.6,2.6-1.7C374.5,773.7,373.4,773.2,371.9,773.2z"
              />
              <path
                className={classes.st12}
                d="M461,778.4v-15.3h-31.7h-1h-34H393h-35.4v28.8h51.7H461V778.4z M374.8,783.1l-2.3-4.5H372h-1.9v4.5h-2.3
			v-11.6h3.8c3.8,0,5.3,1.1,5.3,3.5c0,1.3-0.6,2.4-2.1,3.1l2.6,5H374.8z M387.1,773.3h-6.2v2.9h5.8v1.9h-5.8v3.2h6.2v1.9h-8.5v-11.6
			h8.5V773.3z M393.5,781.4c1.4,0,2.5-0.6,2.9-2.2h2.2c-0.3,2.4-2.3,4-5,4c-3.5,0-5.4-2.4-5.4-6.1c0-3.7,2.1-6,5.5-6
			c2.7,0,4.6,1.6,5,4h-2.2c-0.4-1.6-1.5-2.1-2.8-2.1c-1.7,0-3.1,1.4-3.1,4.1C390.5,780,391.8,781.4,393.5,781.4z M408.4,773.3h-6.2
			v2.9h5.8v1.9h-5.8v3.2h6.2v1.9H400v-11.6h8.5V773.3z M412.2,783.1h-2.3v-11.6h2.3V783.1z M419.5,783.1h-2.3l-4-11.6h2.5l2.8,8.7
			l2.7-8.7h2.4L419.5,783.1z M426.7,783.1h-2.3v-11.6h2.3V783.1z M438.6,783.1h-3l-4.6-8.9v8.9h-2.2v-11.6h3l4.6,8.9v-8.9h2.2V783.1
			z M450.9,783.1h-1.8l-0.1-1.4c-0.7,1-1.8,1.6-3.5,1.6c-3.3,0-5.3-2.4-5.3-6.1c0-3.6,2.1-6,5.7-6c2.7,0,4.6,1.6,4.9,3.7h-2.2
			c-0.4-1.3-1.5-1.9-2.8-1.9c-1.9,0-3.3,1.4-3.3,4.1c0,2.8,1.3,4.2,3.3,4.2c1.2,0,2.9-0.6,2.9-2.5v-0.2h-2.9v-1.9h5V783.1z"
              />
              <path
                d="M376.9,775c0-2.4-1.5-3.5-5.3-3.5h-3.8v11.6h2.3v-4.5h1.9h0.5l2.3,4.5h2.5l-2.6-5C376.2,777.4,376.9,776.3,376.9,775z
			 M372,776.7h-1.9v-3.5h1.8c1.6,0,2.7,0.4,2.7,1.7C374.5,776.1,373.8,776.7,372,776.7z"
              />
              <polygon
                points="378.6,783.1 387.1,783.1 387.1,781.2 380.9,781.2 380.9,778 386.7,778 386.7,776.2 380.9,776.2 380.9,773.3
			387.1,773.3 387.1,771.4 378.6,771.4 		"
              />
              <path
                d="M393.6,773.1c1.3,0,2.4,0.5,2.8,2.1h2.2c-0.4-2.4-2.2-4-5-4c-3.4,0-5.5,2.3-5.5,6c0,3.7,2,6.1,5.4,6.1c2.8,0,4.7-1.7,5-4
			h-2.2c-0.4,1.6-1.5,2.2-2.9,2.2c-1.7,0-3-1.5-3-4.2C390.5,774.5,391.8,773.1,393.6,773.1z"
              />
              <polygon
                points="400,783.1 408.4,783.1 408.4,781.2 402.3,781.2 402.3,778 408.1,778 408.1,776.2 402.3,776.2 402.3,773.3
			408.4,773.3 408.4,771.4 400,771.4 		"
              />
              <rect x="409.9" y="771.4" width="2.3" height="11.6" />
              <polygon points="418.4,780.2 415.6,771.4 413.1,771.4 417.1,783.1 419.5,783.1 423.5,771.4 421.1,771.4 		" />
              <rect x="424.4" y="771.4" width="2.3" height="11.6" />
              <polygon
                points="436.4,780.3 431.8,771.4 428.8,771.4 428.8,783.1 431,783.1 431,774.2 435.6,783.1 438.6,783.1 438.6,771.4
			436.4,771.4 		"
              />
              <path
                d="M445.9,778.8h2.9v0.2c0,1.9-1.7,2.5-2.9,2.5c-2,0-3.3-1.4-3.3-4.2c0-2.8,1.4-4.1,3.3-4.1c1.3,0,2.4,0.6,2.8,1.9h2.2
			c-0.4-2.1-2.2-3.7-4.9-3.7c-3.6,0-5.7,2.4-5.7,6c0,3.7,2,6.1,5.3,6.1c1.6,0,2.8-0.6,3.5-1.6l0.1,1.4h1.8v-6.2h-5V778.8z"
              />
              <path
                className={classes.st12}
                d="M184.1,848.3H183v8h1.1c2.1,0,4.2-0.5,4.2-4C188.3,848.8,186.2,848.3,184.1,848.3z"
              />
              <path
                className={classes.st12}
                d="M209,848.3h-1.8v3.5h1.9c1.8,0,2.6-0.6,2.6-1.7C211.7,848.7,210.5,848.3,209,848.3z"
              />
              <path
                className={classes.st12}
                d="M197.6,848.1c-1.8,0-3.3,1.5-3.3,4.2c0,2.7,1.5,4.2,3.3,4.2s3.3-1.5,3.3-4.2
			C200.9,849.6,199.4,848.1,197.6,848.1z"
              />
              <path
                className={classes.st12}
                d="M223.5,838.1h-31.6h-1.1h-22.1V867H214h1.1h35.7v-28.8h-26.2H223.5z M184.2,858.1h-3.4v-11.6h3.4
			c3.7,0,6.5,1.2,6.5,5.8C190.6,856.9,187.9,858.1,184.2,858.1z M197.6,858.3c-3.5,0-5.7-2.4-5.7-6s2.2-6,5.7-6s5.7,2.4,5.7,6
			S201.1,858.3,197.6,858.3z M211.9,858.1l-2.3-4.5h-0.5h-1.9v4.5h-2.3v-11.6h3.8c3.8,0,5.3,1.1,5.3,3.5c0,1.3-0.6,2.4-2.1,3.1
			l2.6,5H211.9z M234.6,853.3l-1.5-0.3c-1.9-0.4-3.5-1.3-3.5-3.4c0-2.3,2.5-3.4,4.6-3.4c2.4,0,4.4,1.4,4.6,3.6h-2.2
			c-0.2-1.4-1.4-1.8-2.4-1.8c-1.1,0-2.2,0.4-2.2,1.4c0,0.8,0.7,1.3,1.6,1.4l1.5,0.3c1.9,0.4,4,1.1,4,3.5c0,2.4-2.4,3.6-4.7,3.6
			c-2.8,0-4.7-1.5-4.9-4h2.2c0.3,1.7,1.4,2.2,2.8,2.2c1,0,2.3-0.4,2.3-1.6C236.8,853.9,235.9,853.5,234.6,853.3z M228,846.5v11.6
			h-2.1v-8.7l-2.8,8.7h-2.3l-2.9-8.7v8.7h-2.1v-11.6h3.3l2.8,9l2.7-9H228z"
              />
              <path
                d="M184.2,846.5h-3.4v11.6h3.4c3.7,0,6.5-1.2,6.5-5.8C190.6,847.7,187.9,846.5,184.2,846.5z M184.1,856.3H183v-8h1.1
			c2.1,0,4.2,0.5,4.2,4C188.3,855.8,186.2,856.3,184.1,856.3z"
              />
              <path
                d="M197.6,846.3c-3.5,0-5.7,2.4-5.7,6s2.2,6,5.7,6s5.7-2.4,5.7-6S201.1,846.3,197.6,846.3z M197.6,856.5
			c-1.8,0-3.3-1.5-3.3-4.2c0-2.7,1.5-4.2,3.3-4.2s3.3,1.5,3.3,4.2C200.9,855,199.4,856.5,197.6,856.5z"
              />
              <path
                d="M214,850c0-2.4-1.5-3.5-5.3-3.5h-3.8v11.6h2.3v-4.5h1.9h0.5l2.3,4.5h2.5l-2.6-5C213.4,852.4,214,851.4,214,850z
			 M209.1,851.8h-1.9v-3.5h1.8c1.6,0,2.7,0.4,2.7,1.7C211.7,851.2,210.9,851.8,209.1,851.8z"
              />
              <polygon
                points="219.1,846.5 215.7,846.5 215.7,858.1 217.9,858.1 217.9,849.4 220.7,858.1 223,858.1 225.9,849.4 225.9,858.1
			228,858.1 228,846.5 224.6,846.5 221.9,855.5 		"
              />
              <path
                d="M234.5,856.5c-1.4,0-2.6-0.5-2.8-2.2h-2.2c0.2,2.5,2.1,4,4.9,4c2.3,0,4.7-1.2,4.7-3.6c0-2.4-2.1-3.1-4-3.5l-1.5-0.3
			c-0.9-0.2-1.6-0.6-1.6-1.4c0-1,1.2-1.4,2.2-1.4c1.1,0,2.3,0.4,2.4,1.8h2.2c-0.1-2.2-2.2-3.6-4.6-3.6c-2.1,0-4.6,1-4.6,3.4
			c0,2,1.6,3,3.5,3.4l1.5,0.3c1.2,0.2,2.1,0.6,2.1,1.6C236.8,856.1,235.5,856.5,234.5,856.5z"
              />
              <path
                className={classes.st12}
                d="M1250.3,860.1v-28.8h-226.7v28.8h8.2H1240H1250.3z M1040.8,851.2l-2.3-4.5h-0.5h-1.9v4.5h-2.3v-11.6h3.8
			c3.8,0,5.3,1.1,5.3,3.5c0,1.3-0.6,2.4-2.1,3.1l2.6,5H1040.8z M1052,851.2l-0.8-2.4h-4.5l-0.8,2.4h-2.3l4.3-11.6h2.3l4.3,11.6H1052
			z M1060,849.6c1.4,0,2.5-0.6,2.9-2.2h2.2c-0.3,2.4-2.3,4-5,4c-3.5,0-5.4-2.4-5.4-6.1c0-3.7,2.1-6,5.5-6c2.7,0,4.6,1.6,5,4h-2.2
			c-0.4-1.6-1.5-2.1-2.8-2.1c-1.7,0-3.1,1.4-3.1,4.1C1056.9,848.2,1058.3,849.6,1060,849.6z M1074.9,841.5h-6.2v2.9h5.8v1.9h-5.8
			v3.2h6.2v1.9h-8.5v-11.6h8.5V841.5z M1088.4,841.5h-3.6v9.7h-2.3v-9.7h-3.6v-1.9h9.4V841.5z M1096.6,851.2l-2.3-4.5h-0.5h-1.9v4.5
			h-2.3v-11.6h3.8c3.8,0,5.3,1.1,5.3,3.5c0,1.3-0.6,2.4-2.1,3.1l2.6,5H1096.6z M1107.8,851.2l-0.8-2.4h-4.5l-0.8,2.4h-2.3l4.3-11.6
			h2.3l4.3,11.6H1107.8z M1115.8,849.6c1.4,0,2.5-0.6,2.9-2.2h2.2c-0.3,2.4-2.3,4-5,4c-3.5,0-5.4-2.4-5.4-6.1c0-3.7,2.1-6,5.5-6
			c2.7,0,4.6,1.6,5,4h-2.2c-0.4-1.6-1.5-2.1-2.8-2.1c-1.7,0-3.1,1.4-3.1,4.1C1112.7,848.2,1114.1,849.6,1115.8,849.6z M1129.6,851.2
			l-3.4-5.2l-1.6,1.7v3.5h-2.3v-11.6h2.3v5.3l4.7-5.3h2.7l-4.3,4.7l4.6,6.9H1129.6z M1141.8,849.6c1.4,0,2.5-0.6,2.9-2.2h2.2
			c-0.3,2.4-2.3,4-5,4c-3.5,0-5.4-2.4-5.4-6.1c0-3.7,2.1-6,5.5-6c2.7,0,4.6,1.6,5,4h-2.2c-0.4-1.6-1.5-2.1-2.8-2.1
			c-1.7,0-3.1,1.4-3.1,4.1C1138.8,848.2,1140.1,849.6,1141.8,849.6z M1156.2,851.2h-7.9v-11.6h2.3v9.7h5.7V851.2z M1166.7,846.3
			c0,3.8-1.4,5.1-4.8,5.1c-3.4,0-4.8-1.3-4.8-5.1v-6.7h2.3v6.7c0,2,0.4,3.3,2.5,3.3c2.1,0,2.5-1.2,2.5-3.3v-6.7h2.3V846.3z
			 M1173.3,851.2h-4.7v-11.6h4.5c2,0,4.2,0.6,4.2,3c0,1.1-0.7,2.1-1.3,2.4c0.9,0.4,1.7,1.1,1.7,2.7
			C1177.8,850.3,1175.7,851.2,1173.3,851.2z M1192.6,851.2h-2.3v-5h-5.2v5h-2.3v-11.6h2.3v4.7h5.2v-4.7h2.3V851.2z M1199.9,851.5
			c-3.5,0-5.7-2.4-5.7-6s2.2-6,5.7-6c3.5,0,5.7,2.4,5.7,6S1203.4,851.5,1199.9,851.5z M1216.6,846.3c0,3.8-1.4,5.1-4.8,5.1
			c-3.4,0-4.8-1.3-4.8-5.1v-6.7h2.3v6.7c0,2,0.4,3.3,2.5,3.3c2.1,0,2.5-1.2,2.5-3.3v-6.7h2.3V846.3z M1222.8,851.5
			c-2.8,0-4.7-1.5-4.9-4h2.2c0.3,1.7,1.4,2.2,2.8,2.2c1,0,2.3-0.4,2.3-1.6c0-1-0.9-1.4-2.1-1.6l-1.5-0.3c-1.9-0.4-3.5-1.3-3.5-3.4
			c0-2.3,2.5-3.4,4.6-3.4c2.4,0,4.4,1.4,4.6,3.6h-2.2c-0.2-1.4-1.4-1.8-2.4-1.8c-1.1,0-2.2,0.4-2.2,1.4c0,0.8,0.7,1.3,1.6,1.4
			l1.5,0.3c1.9,0.4,4,1.1,4,3.5C1227.6,850.3,1225.2,851.5,1222.8,851.5z M1237.4,841.5h-6.2v2.9h5.8v1.9h-5.8v3.2h6.2v1.9h-8.5
			v-11.6h8.5V841.5z"
              />
              <polygon
                className={classes.st12}
                points="1103.1,847 1106.4,847 1104.8,842.4 		"
              />
              <path
                className={classes.st12}
                d="M1199.9,841.3c-1.8,0-3.3,1.5-3.3,4.2c0,2.7,1.5,4.2,3.3,4.2c1.8,0,3.3-1.5,3.3-4.2
			C1203.2,842.7,1201.7,841.3,1199.9,841.3z"
              />
              <path
                className={classes.st12}
                d="M1093.6,841.4h-1.8v3.5h1.9c1.8,0,2.6-0.6,2.6-1.7C1096.3,841.8,1095.2,841.4,1093.6,841.4z"
              />
              <polygon
                className={classes.st12}
                points="1047.3,847 1050.5,847 1048.9,842.4 		"
              />
              <path
                className={classes.st12}
                d="M1037.8,841.4h-1.8v3.5h1.9c1.8,0,2.6-0.6,2.6-1.7C1040.5,841.8,1039.3,841.4,1037.8,841.4z"
              />
              <path
                className={classes.st12}
                d="M1175,842.9c0-0.9-0.7-1.5-1.7-1.5h-2.4v3h2.4C1174.4,844.4,1175,843.9,1175,842.9z"
              />
              <path
                className={classes.st12}
                d="M1173.3,846.2h-2.4v3.3h2.5c1.3,0,2-0.5,2-1.6C1175.4,846.7,1174.8,846.2,1173.3,846.2z"
              />
              <path
                d="M1042.8,843.2c0-2.4-1.5-3.5-5.3-3.5h-3.8v11.6h2.3v-4.5h1.9h0.5l2.3,4.5h2.5l-2.6-5
			C1042.2,845.6,1042.8,844.5,1042.8,843.2z M1037.9,844.9h-1.9v-3.5h1.8c1.6,0,2.7,0.4,2.7,1.7
			C1040.5,844.3,1039.7,844.9,1037.9,844.9z"
              />
              <path d="M1047.8,839.6l-4.3,11.6h2.3l0.8-2.4h4.5l0.8,2.4h2.5l-4.3-11.6H1047.8z M1047.3,847l1.6-4.6l1.6,4.6H1047.3z" />
              <path
                d="M1060,841.3c1.3,0,2.4,0.5,2.8,2.1h2.2c-0.4-2.4-2.2-4-5-4c-3.4,0-5.5,2.3-5.5,6c0,3.7,2,6.1,5.4,6.1c2.8,0,4.7-1.7,5-4
			h-2.2c-0.4,1.6-1.5,2.2-2.9,2.2c-1.7,0-3-1.5-3-4.2C1056.9,842.7,1058.3,841.3,1060,841.3z"
              />
              <polygon
                points="1066.5,851.2 1074.9,851.2 1074.9,849.4 1068.7,849.4 1068.7,846.2 1074.6,846.2 1074.6,844.4 1068.7,844.4
			1068.7,841.5 1074.9,841.5 1074.9,839.6 1066.5,839.6 		"
              />
              <polygon points="1079,841.5 1082.6,841.5 1082.6,851.2 1084.8,851.2 1084.8,841.5 1088.4,841.5 1088.4,839.6 1079,839.6 		" />
              <path
                d="M1098.6,843.2c0-2.4-1.5-3.5-5.3-3.5h-3.8v11.6h2.3v-4.5h1.9h0.5l2.3,4.5h2.5l-2.6-5
			C1098,845.6,1098.6,844.5,1098.6,843.2z M1093.7,844.9h-1.9v-3.5h1.8c1.6,0,2.7,0.4,2.7,1.7
			C1096.3,844.3,1095.5,844.9,1093.7,844.9z"
              />
              <path d="M1103.7,839.6l-4.3,11.6h2.3l0.8-2.4h4.5l0.8,2.4h2.5l-4.3-11.6H1103.7z M1103.1,847l1.6-4.6l1.6,4.6H1103.1z" />
              <path
                d="M1115.9,841.3c1.3,0,2.4,0.5,2.8,2.1h2.2c-0.4-2.4-2.2-4-5-4c-3.4,0-5.5,2.3-5.5,6c0,3.7,2,6.1,5.4,6.1c2.8,0,4.7-1.7,5-4
			h-2.2c-0.4,1.6-1.5,2.2-2.9,2.2c-1.7,0-3-1.5-3-4.2C1112.7,842.7,1114.1,841.3,1115.9,841.3z"
              />
              <polygon
                points="1132,839.6 1129.3,839.6 1124.6,845 1124.6,839.6 1122.3,839.6 1122.3,851.2 1124.6,851.2 1124.6,847.8
			1126.2,846 1129.6,851.2 1132.3,851.2 1127.7,844.3 		"
              />
              <path
                d="M1141.9,841.3c1.3,0,2.4,0.5,2.8,2.1h2.2c-0.4-2.4-2.2-4-5-4c-3.4,0-5.5,2.3-5.5,6c0,3.7,2,6.1,5.4,6.1c2.8,0,4.7-1.7,5-4
			h-2.2c-0.4,1.6-1.5,2.2-2.9,2.2c-1.7,0-3-1.5-3-4.2C1138.8,842.7,1140.1,841.3,1141.9,841.3z"
              />
              <polygon points="1150.6,839.6 1148.3,839.6 1148.3,851.2 1156.2,851.2 1156.2,849.4 1150.6,849.4 		" />
              <path
                d="M1164.4,846.3c0,2-0.4,3.3-2.5,3.3c-2.1,0-2.5-1.2-2.5-3.3v-6.7h-2.3v6.7c0,3.8,1.4,5.1,4.8,5.1c3.4,0,4.8-1.3,4.8-5.1
			v-6.7h-2.3V846.3z"
              />
              <path
                d="M1176,845.1c0.6-0.4,1.3-1.4,1.3-2.4c0-2.4-2.2-3-4.2-3h-4.5v11.6h4.7c2.4,0,4.5-0.9,4.5-3.4
			C1177.8,846.2,1176.9,845.5,1176,845.1z M1170.9,841.4h2.4c1.1,0,1.7,0.5,1.7,1.5c0,1-0.6,1.5-1.7,1.5h-2.4V841.4z M1173.4,849.4
			h-2.5v-3.3h2.4c1.4,0,2.1,0.6,2.1,1.7C1175.4,848.9,1174.8,849.4,1173.4,849.4z"
              />
              <polygon
                points="1190.3,844.4 1185.1,844.4 1185.1,839.6 1182.8,839.6 1182.8,851.2 1185.1,851.2 1185.1,846.2 1190.3,846.2
			1190.3,851.2 1192.6,851.2 1192.6,839.6 1190.3,839.6 		"
              />
              <path
                d="M1199.9,839.4c-3.5,0-5.7,2.4-5.7,6s2.2,6,5.7,6c3.5,0,5.7-2.4,5.7-6S1203.4,839.4,1199.9,839.4z M1199.9,849.6
			c-1.8,0-3.3-1.5-3.3-4.2c0-2.7,1.5-4.2,3.3-4.2c1.8,0,3.3,1.5,3.3,4.2C1203.2,848.2,1201.7,849.6,1199.9,849.6z"
              />
              <path
                d="M1214.4,846.3c0,2-0.4,3.3-2.5,3.3c-2.1,0-2.5-1.2-2.5-3.3v-6.7h-2.3v6.7c0,3.8,1.4,5.1,4.8,5.1c3.4,0,4.8-1.3,4.8-5.1
			v-6.7h-2.3V846.3z"
              />
              <path
                d="M1223.6,844.4l-1.5-0.3c-0.9-0.2-1.6-0.6-1.6-1.4c0-1,1.2-1.4,2.2-1.4c1.1,0,2.3,0.4,2.4,1.8h2.2
			c-0.1-2.2-2.2-3.6-4.6-3.6c-2.1,0-4.6,1-4.6,3.4c0,2,1.6,3,3.5,3.4l1.5,0.3c1.2,0.2,2.1,0.6,2.1,1.6c0,1.2-1.3,1.6-2.3,1.6
			c-1.4,0-2.6-0.5-2.8-2.2h-2.2c0.2,2.5,2.1,4,4.9,4c2.3,0,4.7-1.2,4.7-3.6C1227.6,845.5,1225.5,844.8,1223.6,844.4z"
              />
              <polygon
                points="1229,851.2 1237.4,851.2 1237.4,849.4 1231.2,849.4 1231.2,846.2 1237.1,846.2 1237.1,844.4 1231.2,844.4
			1231.2,841.5 1237.4,841.5 1237.4,839.6 1229,839.6 		"
              />
              <rect x="157.9" y="140.2" width="327.7" height="0.5" />
              <path
                d="M67.9,139.9l-1.4-0.3c-0.9-0.2-1.5-0.6-1.5-1.4c0-1,1.1-1.3,2.1-1.3c1,0,2.1,0.4,2.3,1.7h2.1c-0.1-2.1-2-3.4-4.3-3.4
			c-2,0-4.3,1-4.3,3.1c0,1.9,1.5,2.8,3.3,3.1l1.4,0.3c1.2,0.2,2,0.6,2,1.5c0,1.2-1.2,1.5-2.2,1.5c-1.3,0-2.4-0.5-2.6-2.1h-2.1
			c0.2,2.3,2,3.8,4.6,3.8c2.2,0,4.4-1.1,4.4-3.3C71.6,140.9,69.7,140.3,67.9,139.9z"
              />
              <polygon points="80.7,135.5 71.8,135.5 71.8,137.2 75.2,137.2 75.2,146.3 77.3,146.3 77.3,137.2 80.7,137.2 		" />
              <path d="M83.3,135.5l-4.1,10.9h2.2l0.8-2.2h4.2l0.8,2.2h2.3l-4.1-10.9H83.3z M82.8,142.4l1.5-4.3l1.5,4.3H82.8z" />
              <path
                d="M97.5,140.6c0.6-0.4,1.2-1.3,1.2-2.3c0-2.2-2.1-2.8-4-2.8h-4.2v10.9h4.4c2.2,0,4.2-0.9,4.2-3.2
			C99.1,141.6,98.3,141,97.5,140.6z M92.7,137.1h2.2c1,0,1.6,0.5,1.6,1.4c0,1-0.6,1.4-1.6,1.4h-2.2V137.1z M95,144.7h-2.4v-3.1h2.3
			c1.3,0,2,0.5,2,1.6S96.3,144.7,95,144.7z"
              />
              <polygon points="102.6,135.5 100.5,135.5 100.5,146.3 107.9,146.3 107.9,144.6 102.6,144.6 		" />
              <polygon
                points="108.9,146.3 116.8,146.3 116.8,144.6 111,144.6 111,141.6 116.5,141.6 116.5,139.9 111,139.9 111,137.2
			116.8,137.2 116.8,135.5 108.9,135.5 		"
              />
              <polygon
                points="127.3,143.9 124.6,135.5 121.5,135.5 121.5,146.3 123.5,146.3 123.5,138.2 126.2,146.3 128.3,146.3 131,138.2
			131,146.3 133,146.3 133,135.5 129.9,135.5 		"
              />
              <path d="M137.9,135.5l-4,10.9h2.2l0.8-2.2h4.2l0.8,2.2h2.3l-4.1-10.9H137.9z M137.4,142.4l1.5-4.3l1.5,4.3H137.4z" />
              <path
                d="M148.8,135.5h-3.7v10.9h2.1v-3.8h1.6c2.5,0,4.7-0.7,4.7-3.5C153.6,135.8,151,135.5,148.8,135.5z M149,140.8h-1.8v-3.7h1.6
			c1.2,0,2.5,0.2,2.5,1.9C151.4,140.5,150.3,140.8,149,140.8z"
              />
              <path
                d="M63.4,1044.3h-2.8l-2.3,10.9h0.3l1-4.8h2.6c2.8,0,5.1-0.8,5.1-3.7C67.3,1044.9,65.8,1044.3,63.4,1044.3z M62.2,1050.1
			h-2.5l1.2-5.5h2.6c2,0,3.6,0.4,3.6,2.1C67,1049.6,64.6,1050.1,62.2,1050.1z"
              />
              <path
                d="M75.7,1050.8c-0.6,2.9-1.8,4.3-4.6,4.3c-2.3,0-3.3-0.9-3.3-2.8c0-0.5,0.1-1,0.2-1.5l1.4-6.5h-0.3l-1.4,6.5
			c-0.1,0.6-0.2,1.1-0.2,1.6c0,2.1,1.2,3,3.6,3c2.9,0,4.2-1.5,4.9-4.6l1.4-6.5H77L75.7,1050.8z"
              />
              <path
                d="M77.4,1055.2h3.9c0.3,0,0.6,0,0.9,0c2.2-0.2,3.6-1.3,3.6-3.4c0-1.4-0.9-2.1-2-2.2c1.8-0.3,2.6-1.5,2.6-3
			c0-1.6-1.3-2.2-3.1-2.2h-1.1h-2.5L77.4,1055.2z M85.4,1051.8c0,1.9-1.4,2.9-3.2,3.1c-0.3,0-0.6,0-0.9,0h-3.5l1.1-5.2h3.3h0.3
			C84.5,1049.7,85.4,1050.3,85.4,1051.8z M82.2,1044.6h1.1c1.8,0,2.7,0.7,2.7,1.9c0,2.2-1.7,2.9-3.5,2.9h-0.3H79l1-4.8H82.2z"
              />
              <polygon points="89.8,1044.3 89.5,1044.3 87.2,1055.2 93.7,1055.2 93.7,1054.9 87.5,1054.9 		" />
              <polygon points="95,1055.2 95.3,1055.2 97.6,1044.3 97.3,1044.3 		" />
              <path
                d="M102.6,1044.1c-1.8,0-3.6,0.8-3.6,2.6c0,1.5,1.1,2.3,2.5,2.7l1.3,0.4c1.6,0.5,2.9,1.1,2.9,2.6c0,2-2,2.7-3.7,2.7
			c-2,0-3.5-1-3.8-3.1l-0.3,0c0.3,2.3,2,3.3,4.2,3.3c2,0,4-1,4-3c0-1.8-1.7-2.5-3.1-2.9l-1.3-0.4c-1.4-0.4-2.2-1.1-2.2-2.4
			c0-1.7,1.7-2.3,3.2-2.3c1.8,0,3.2,0.8,3.6,2.7l0.3,0C106.2,1045,104.4,1044.1,102.6,1044.1z"
              />
              <polygon
                points="116.1,1049.4 108.9,1049.4 110,1044.3 109.7,1044.3 107.4,1055.2 107.7,1055.2 108.9,1049.7 116.1,1049.7
			114.9,1055.2 115.2,1055.2 117.5,1044.3 117.2,1044.3 		"
              />
              <polygon
                points="120.3,1044.6 126.7,1044.6 126.8,1044.3 120.1,1044.3 117.8,1055.2 124.5,1055.2 124.5,1054.9 118.1,1054.9
			119.3,1049.7 125.3,1049.7 125.3,1049.4 119.3,1049.4 		"
              />
              <path
                d="M131.1,1044.3h-2.5l-2.3,10.9h3.5c4.3,0,6.2-3,6.2-6.2C136,1045.9,134.3,1044.3,131.1,1044.3z M129.7,1054.9h-3.1
			l2.2-10.3h2.3c3.1,0,4.5,1.8,4.5,4.3C135.6,1052.1,133.9,1054.9,129.7,1054.9z"
              />
              <path d="M145.3,1044.3l-6.5,10.9h0.4l1.9-3.1h5.6l0.6,3.1h0.3l-2-10.9H145.3z M141.2,1051.7l4.2-7l1.3,7H141.2z" />
              <path
                d="M157.5,1050.8c-0.6,2.9-1.8,4.3-4.6,4.3c-2.3,0-3.3-0.9-3.3-2.8c0-0.5,0.1-1,0.2-1.5l1.4-6.5H151l-1.4,6.5
			c-0.1,0.6-0.2,1.1-0.2,1.6c0,2.1,1.2,3,3.6,3c2.9,0,4.2-1.5,4.9-4.6l1.4-6.5h-0.3L157.5,1050.8z"
              />
              <path
                d="M165.4,1044.1c-3.9,0-5.7,3.8-5.7,6.7c0,2.8,1.6,4.6,4.3,4.6c2.6,0,3.8-1.3,4.4-2.5l-0.5,2.3h0.3l1.1-5.1h-3.5l-0.1,0.3
			h3.2l-0.1,0.5c-0.6,3-2.4,4.1-4.8,4.1c-2.7,0-4-1.8-4-4.2c0-3,1.8-6.4,5.3-6.4c2.2,0,3.8,1.2,4,3.3h0.3
			C169.4,1045.3,167.6,1044.1,165.4,1044.1z"
              />
              <path
                d="M179.4,1050.8c-0.6,2.9-1.8,4.3-4.6,4.3c-2.3,0-3.3-0.9-3.3-2.8c0-0.5,0.1-1,0.2-1.5l1.4-6.5h-0.3l-1.4,6.5
			c-0.1,0.6-0.2,1.1-0.2,1.6c0,2.1,1.2,3,3.6,3c2.9,0,4.2-1.5,4.9-4.6l1.4-6.5h-0.3L179.4,1050.8z"
              />
              <path
                d="M185.9,1044.1c-1.8,0-3.6,0.8-3.6,2.6c0,1.5,1.1,2.3,2.5,2.7l1.3,0.4c1.6,0.5,2.9,1.1,2.9,2.6c0,2-2,2.7-3.7,2.7
			c-2,0-3.5-1-3.8-3.1l-0.3,0c0.3,2.3,2,3.3,4.2,3.3c2,0,4-1,4-3c0-1.8-1.7-2.5-3.1-2.9l-1.3-0.4c-1.4-0.4-2.2-1.1-2.2-2.4
			c0-1.7,1.7-2.3,3.2-2.3c1.8,0,3.2,0.8,3.6,2.7l0.3,0C189.5,1045,187.7,1044.1,185.9,1044.1z"
              />
              <polygon points="190.6,1044.6 194.5,1044.6 192.3,1055.2 192.6,1055.2 194.8,1044.6 198.7,1044.6 198.8,1044.3 190.7,1044.3 		" />
              <path
                d="M209.4,1046.7c0-1.9-1.9-2.6-3.6-2.6c-1.7,0-3.5,0.8-3.5,2.7c0,1.1,0.7,2.1,2,2.4c-1.7,0.2-3.1,1.3-3.1,3
			c0,2.1,2,3.1,3.8,3.1c2.2,0,4-1.1,4-3.3c0-1.7-1.2-2.4-2.3-2.7C208.1,1049.2,209.4,1048.2,209.4,1046.7z M208.7,1052.1
			c0,1.8-1.4,3-3.6,3c-1.4,0-3.5-0.7-3.5-2.8c0-1.7,1.4-2.8,3.5-2.8C206.7,1049.4,208.7,1050.1,208.7,1052.1z M205.8,1049.2
			c-1.4,0-3.2-0.6-3.2-2.4c0-1.6,1.4-2.4,3.1-2.4c1.3,0,3.2,0.5,3.2,2.4C209.1,1048.3,207.7,1049.2,205.8,1049.2z"
              />
              <path d="M210.4,1055.2c-0.3,1.3-0.3,1.6-0.8,1.7l-0.1,0.3c0.7-0.1,0.8-0.6,1.1-2l0.3-1.4h-0.3L210.4,1055.2z" />
              <path
                d="M224.6,1046.8c0-1.5-1.1-2.7-3.2-2.7c-2.6,0-3.7,1.6-3.8,3.4h0.3c0.2-1.9,1.3-3.1,3.5-3.1c1.8,0,2.9,1,2.9,2.4
			c0,2.6-3.1,4.8-8.5,8.1l0,0.3h7.5l0-0.3h-7C221.3,1052,224.6,1049.5,224.6,1046.8z"
              />
              <path
                d="M230.4,1044.1c-3.5,0-4.7,3.9-4.7,6.8c0,2.6,1.3,4.5,3.8,4.5c3.5,0,4.7-3.9,4.7-6.8
			C234.2,1045.9,232.9,1044.1,230.4,1044.1z M229.5,1055.1c-2.3,0-3.5-1.6-3.5-4.2c0-2.8,1.1-6.5,4.3-6.5c2.3,0,3.5,1.6,3.5,4.2
			C233.9,1051.4,232.8,1055.1,229.5,1055.1z"
              />
              <path
                d="M243,1046.8c0-1.5-1.1-2.7-3.2-2.7c-2.6,0-3.7,1.6-3.8,3.4h0.3c0.2-1.9,1.3-3.1,3.5-3.1c1.8,0,2.9,1,2.9,2.4
			c0,2.6-3.1,4.8-8.5,8.1l0,0.3h7.5l0-0.3h-7C239.6,1052,243,1049.5,243,1046.8z"
              />
              <path
                d="M251.3,1046.8c0-1.5-1.1-2.7-3.2-2.7c-2.6,0-3.7,1.6-3.8,3.4h0.3c0.2-1.9,1.3-3.1,3.5-3.1c1.8,0,2.9,1,2.9,2.4
			c0,2.6-3.1,4.8-8.5,8.1l0,0.3h7.5l0-0.3h-7C247.9,1052,251.3,1049.5,251.3,1046.8z"
              />
              <path
                id="GSP_Mark"
                className={classes.st13}
                d="M124.1,96c-0.3-0.2-1.9-1.2-2.4-1.5c-7.3-4.1-19.4-3.2-30.7-6.1c-10.7-2.8-20.7-9.1-24.9-26.5
			c7.2,8.4,19.8,12.6,32.8,18.3l0,0c3.6,1.6,7.3,3.3,10.8,5.3C116.8,89.3,121,92.5,124.1,96z M152.7,69.7c0,0-0.7-0.5-1.6-0.2
			c-0.6,0.2-1.3,0.8-1.3,1.6c0,2.2,0,7,0,11.2c0,4.2,0,7.9,0,7.9h-3.6c0,0-3-4.4-5.2-6.4c-0.5-0.4-1.2-0.7-1.9-0.5
			c-0.8,0.2-1.5,0.9-1.6,1.7c-0.1,0.5,0,1,0.2,1.4c0.8,1.4,1.5,2.9,2,4.4c1.9,5.7,2.9,11.7,2.9,17.8v7.6c-1.6-5.1-3.5-9.5-5.5-13.2
			c-5.7-10.7-12.4-15.9-17.9-19.4c-4.3-2.8-8.8-5.1-13.4-7.2l-4.4-2l-11.7-5.3c-0.1,0-0.2-0.1-0.4-0.2c-2-1-3.9-2-5.7-3
			c-0.8-0.5-1.7-1-2.5-1.5c-10.5-7.1-13.5-15.3-14.3-20.1c-0.2-1.2-0.3-2.4-0.3-3.7c0-0.1,0-0.2,0-0.3c2.3,4.9,6.2,9,10.9,12.6
			c4.8,3.6,10.5,6.7,16.5,9.7c3.7,1.8,7.4,3.5,11.2,5.2c1.1,0.5,7.2,3.1,10.3,4.6c1.4,0.7,1.9,0.8,3.2-0.1c2.1-1.5,5.5-3.6,5.9-3.8
			c0.1,0,0.2-0.1,0.2-0.1c0.7-0.4,1.5-0.7,2.2-1.1c1-0.4,2-0.8,3-1.1c0,0,1.6-0.5,2.1-0.6c0.3,0,0.5-0.1,0.8-0.2h0
			c0.1,0,0.3,0,0.4-0.1c1.9-0.3,3.9-0.4,5.9-0.3c0.1,0,0.2,0,0.3,0c0.8,0,1.6,0.1,2.4,0.3c1.6,0.2,3.3,0.6,4.8,1.2
			c0.6,0.2,1.9,0.8,3.2,1.4C151.2,68.6,152.4,69.3,152.7,69.7z"
              />
              <path
                id="Border"
                className={classes.st13}
                d="M486.5,120.8H61.6V36h424.9V120.8L486.5,120.8z M62,120.5h424.1v-84H62V120.5z"
              />
              <path
                id="GULFSTREAM_PARK"
                className={classes.st13}
                d="M200.6,50.9h-4.9c-1.2-4-4.5-6.8-10.2-6.8c-6.4,0-11.3,4.9-11.3,14.3
			c0,9.1,4.7,14.4,11.3,14.4c4.8,0,10.6-2,10.6-9.4v-0.9h-9.5V58h14.3v18.3h-4l-0.2-4.5c-2.3,3.7-6.6,5.2-11.4,5.2
			c-10.4,0-16.3-7.7-16.3-18.7c0-11.2,6.6-18.6,16.7-18.6C193.2,39.8,199.1,43.9,200.6,50.9z M212.2,40.4v21.9
			c0,7,2.5,10.4,9.3,10.4c6.9,0,9.4-3.8,9.4-10.9V40.4h5.1v20.9c0,10.5-4,15.7-14.5,15.7c-10,0-14.3-4.1-14.3-15.3V40.4H212.2z
			 M247.8,72h19v4.4h-24.1v-36h5V72L247.8,72z M269.8,40.4h23.4v4.4h-18.3v10.9h17.3v4.4h-17.3v16.3h-5.1L269.8,40.4L269.8,40.4z
			 M307.9,39.8c6.5,0,12.3,2.9,13.6,9.8h-4.9c-1.2-4.2-5.3-5.6-8.9-5.6c-2.8,0-7.6,1.2-7.6,5.3c0,3.2,2.5,4.8,5.9,5.5l4.2,0.9
			c5.5,1.2,12.1,3.3,12.1,10.5c0,7-6.6,10.8-13.7,10.8c-8.5,0-13.8-4.6-14.8-11.8h5c0.9,4.9,4.4,7.5,9.9,7.5c5.3,0,8.4-2.5,8.4-6.1
			c0-3.8-3.2-5.4-7.7-6.4l-4.5-0.9c-4.9-1.1-9.9-3.8-9.9-9.8C294.9,42.7,302.1,39.8,307.9,39.8z M333.9,44.8h-11.7v-4.4h28.5v4.4
			h-11.7v31.6h-5.1L333.9,44.8L333.9,44.8z M367.8,61.2c-0.9,0-1.8,0-2.7,0h-6.4v15.1h-5.1v-36H365c8.8,0,15,1.7,15,10.4
			c0,5.7-2.7,8.4-7.1,9.6l8.3,16h-5.7L367.8,61.2z M358.7,44.7V57h6.7c5.3,0,9.4-0.5,9.4-6.1s-4.1-6.2-9.4-6.2H358.7z M386.1,40.4
			h24.4v4.4h-19.4v10.9h18.2v4.4h-18.2v12h19.4v4.4h-24.4V40.4z M424.4,40.4h5.9l13.5,36h-5.5l-2.8-7.8H419l-2.8,7.8H411L424.4,40.4
			z M420.5,64.3h13.4l-6.7-18.8L420.5,64.3z M461.8,76.4L451.9,45v31.3h-5.1v-36h8.5l9.2,30l9.2-30h8.5v36h-5.1V45l-9.9,31.3H461.8z
			 M182.5,81.5c8.8,0,14.9,2,14.9,10.9c0,8.9-6.2,10.9-14.9,10.9h-6.2v14.2h-5v-36H182.5L182.5,81.5z M176.3,85.8v13.1h6.6
			c5.3,0,9.4-0.5,9.4-6.5c0-5.9-4.1-6.6-9.4-6.6C182.9,85.8,176.3,85.8,176.3,85.8z M207,81.5h5.9l13.5,36h-5.5l-2.8-7.8h-16.5
			l-2.8,7.8h-5.2L207,81.5z M203.1,105.4h13.4l-6.7-18.8L203.1,105.4z M243.5,102.3c-0.9,0-1.8,0-2.7,0h-6.4v15.1h-5v-36h11.4
			c8.8,0,15,1.7,15,10.4c0,5.7-2.7,8.4-7.1,9.6l8.3,16h-5.7L243.5,102.3z M234.5,85.8v12.3h6.7c5.3,0,9.4-0.5,9.4-6.1
			c0-5.6-4.1-6.2-9.4-6.2H234.5L234.5,85.8z M266.9,99.6l16.2-18.1h6.3L276,96.2l15,21.3h-6.1l-12.4-17.6l-5.7,6.3v11.3h-5v-36h5
			L266.9,99.6L266.9,99.6z"
              />
            </g>
          </g>
          <g onClick={handleGroupClick}>
            <g
              data-name="8"
              className={clsx(classes.barn, {
                [classes.hasHorses]: barnsWithHorses["8"]
              })}
            >
              <rect
                x="260.9"
                y="225.3"
                className={classes.barnPath}
                width="22.7"
                height="145"
              />
              <circle
                className={classes.circle}
                cx="272.3"
                cy="279.6"
                r="16.7"
              />
              <text
                transform="matrix(1 0 0 1 267.2865 284.5139)"
                className={clsx(classes.st15, classes.st16)}
              >
                8
              </text>
            </g>
            <g
              data-name="9"
              className={clsx(classes.barn, {
                [classes.hasHorses]: barnsWithHorses["9"]
              })}
            >
              <rect
                x="313.8"
                y="225.3"
                className={classes.barnPath}
                width="22.7"
                height="145"
              />
              <circle
                className={classes.circle}
                cx="325.1"
                cy="279.6"
                r="16.7"
              />
              <text
                transform="matrix(1 0 0 1 320.3343 284.5139)"
                className={clsx(classes.st15, classes.st16)}
              >
                9
              </text>
            </g>
            <g
              data-name="10"
              className={clsx(classes.barn, {
                [classes.hasHorses]: barnsWithHorses["10"]
              })}
            >
              <rect
                x="366.6"
                y="225.3"
                className={classes.barnPath}
                width="22.7"
                height="145"
              />
              <circle className={classes.circle} cx="378" cy="279.6" r="16.7" />
              <text
                transform="matrix(1 0 0 1 370.0188 284.5139)"
                className={clsx(classes.st15, classes.st16)}
              >
                10
              </text>
            </g>
            <g
              data-name="11"
              className={clsx(classes.barn, {
                [classes.hasHorses]: barnsWithHorses["11"]
              })}
            >
              <rect
                x="419.5"
                y="225.3"
                className={classes.barnPath}
                width="22.7"
                height="145"
              />
              <circle
                className={classes.circle}
                cx="430.8"
                cy="279.6"
                r="16.7"
              />
              <text
                transform="matrix(1 0 0 1 425.2287 284.5139)"
                className={clsx(classes.st15, classes.st16)}
              >
                11
              </text>
            </g>
            <g
              data-name="12"
              className={clsx(classes.barn, {
                [classes.hasHorses]: barnsWithHorses["12"]
              })}
            >
              <rect
                x="472.3"
                y="225.3"
                className={classes.barnPath}
                width="22.7"
                height="145"
              />
              <circle
                className={classes.circle}
                cx="483.7"
                cy="279.6"
                r="16.7"
              />
              <text
                transform="matrix(1 0 0 1 476.3586 284.5139)"
                className={clsx(classes.st15, classes.st16)}
              >
                12
              </text>
            </g>
            <g
              data-name="14"
              className={clsx(classes.barn, {
                [classes.hasHorses]: barnsWithHorses["14"]
              })}
            >
              <rect
                x="525.2"
                y="225.3"
                className={classes.barnPath}
                width="22.7"
                height="106.8"
              />
              <circle
                className={classes.circle}
                cx="536.5"
                cy="279.6"
                r="16.7"
              />
              <text
                transform="matrix(1 0 0 1 528.8566 284.5139)"
                className={clsx(classes.st15, classes.st16)}
              >
                14
              </text>
            </g>
            <g
              data-name="15"
              className={clsx(classes.barn, {
                [classes.hasHorses]: barnsWithHorses["15"]
              })}
            >
              <rect
                x="661.3"
                y="168.1"
                transform="matrix(-1.836970e-16 1 -1 -1.836970e-16 914.7919 -430.5762)"
                className={classes.barnPath}
                width="22.7"
                height="147.9"
              />
              <circle
                className={classes.circle}
                cx="670.6"
                cy="242.1"
                r="16.7"
              />
              <text
                transform="matrix(1 0 0 1 663.0102 247.0473)"
                className={clsx(classes.st15, classes.st16)}
              >
                15
              </text>
            </g>
            <g
              data-name="16"
              className={clsx(classes.barn, {
                [classes.hasHorses]: barnsWithHorses["16"]
              })}
            >
              <rect
                x="830.6"
                y="168.1"
                transform="matrix(-1.836970e-16 1 -1 -1.836970e-16 1084.0819 -599.8662)"
                className={classes.barnPath}
                width="22.7"
                height="147.9"
              />
              <circle className={classes.circle} cx="842" cy="241.5" r="16.7" />
              <text
                transform="matrix(1 0 0 1 834.3273 246.4227)"
                className={clsx(classes.st15, classes.st16)}
              >
                16
              </text>
            </g>
            <g
              data-name="17"
              className={clsx(classes.barn, {
                [classes.hasHorses]: barnsWithHorses["17"]
              })}
            >
              <rect
                x="998.6"
                y="168.1"
                transform="matrix(-1.836970e-16 1 -1 -1.836970e-16 1252.0277 -767.812)"
                className={classes.barnPath}
                width="22.7"
                height="147.9"
              />
              <circle
                className={classes.circle}
                cx="1009.9"
                cy="241.5"
                r="16.7"
              />
              <text
                transform="matrix(1 0 0 1 1003.2087 246.4227)"
                className={clsx(classes.st15, classes.st16)}
              >
                17
              </text>
            </g>
            <g
              data-name="18"
              className={clsx(classes.barn, {
                [classes.hasHorses]: barnsWithHorses["18"]
              })}
            >
              <rect
                x="1168.9"
                y="168.1"
                transform="matrix(-1.836970e-16 1 -1 -1.836970e-16 1422.35 -938.1343)"
                className={classes.barnPath}
                width="22.7"
                height="147.9"
              />
              <circle
                className={classes.circle}
                cx="1169.3"
                cy="241.5"
                r="16.7"
              />
              <text
                transform="matrix(1 0 0 1 1161.5364 246.4227)"
                className={clsx(classes.st15, classes.st16)}
              >
                18
              </text>
            </g>
            <g
              data-name="19"
              className={clsx(classes.barn, {
                [classes.hasHorses]: barnsWithHorses["19"]
              })}
            >
              <rect
                x="1361.4"
                y="168.1"
                transform="matrix(-1.836970e-16 1 -1 -1.836970e-16 1614.8657 -1130.65)"
                className={classes.barnPath}
                width="22.7"
                height="147.9"
              />
              <circle
                className={classes.circle}
                cx="1372.8"
                cy="241.5"
                r="16.7"
              />
              <text
                transform="matrix(1 0 0 1 1365.1746 246.4227)"
                className={clsx(classes.st15, classes.st16)}
              >
                19
              </text>
            </g>
            <g
              data-name="20"
              className={clsx(classes.barn, {
                [classes.hasHorses]: barnsWithHorses["20"]
              })}
            >
              <rect
                x="1529.1"
                y="168.1"
                transform="matrix(-1.836970e-16 1 -1 -1.836970e-16 1782.6073 -1298.3916)"
                className={classes.barnPath}
                width="22.7"
                height="147.9"
              />
              <circle
                className={classes.circle}
                cx="1540.5"
                cy="241.5"
                r="16.7"
              />
              <text
                transform="matrix(1 0 0 1 1530.8254 246.4227)"
                className={clsx(classes.st15, classes.st16)}
              >
                20
              </text>
            </g>
            <g
              data-name="21"
              className={clsx(classes.barn, {
                [classes.hasHorses]: barnsWithHorses["21"]
              })}
            >
              <rect
                x="1573.5"
                y="330.5"
                transform="matrix(-1 -1.224647e-16 1.224647e-16 -1 3176.1609 831.3023)"
                className={classes.barnPath}
                width="29.1"
                height="170.4"
              />
              <circle
                className={classes.circle}
                cx="1588.1"
                cy="410.6"
                r="16.7"
              />
              <text
                transform="matrix(1 0 0 1 1580.7639 415.5515)"
                className={clsx(classes.st15, classes.st16)}
              >
                21
              </text>
            </g>
            <g
              data-name="22"
              className={clsx(classes.barn, {
                [classes.hasHorses]: barnsWithHorses["22"]
              })}
            >
              <rect
                x="1614.5"
                y="330.5"
                transform="matrix(-1 -1.224647e-16 1.224647e-16 -1 3258.0242 831.3023)"
                className={classes.barnPath}
                width="29.1"
                height="170.4"
              />
              <circle
                className={classes.circle}
                cx="1629"
                cy="410.6"
                r="16.7"
              />
              <text
                transform="matrix(1 0 0 1 1619.9749 415.5515)"
                className={clsx(classes.st15, classes.st16)}
              >
                22
              </text>
            </g>
            <g
              data-name="23"
              className={clsx(classes.barn, {
                [classes.hasHorses]: barnsWithHorses["23"]
              })}
            >
              <rect
                x="1659.4"
                y="547.2"
                transform="matrix(-1 -1.224647e-16 1.224647e-16 -1 3347.8303 1264.8499)"
                className={classes.barnPath}
                width="29.1"
                height="170.4"
              />
              <circle
                className={classes.circle}
                cx="1673.9"
                cy="629.7"
                r="16.7"
              />
              <text
                transform="matrix(1 0 0 1 1664.6738 634.6595)"
                className={clsx(classes.st15, classes.st16)}
              >
                23
              </text>
            </g>
            <g
              data-name="24"
              className={clsx(classes.barn, {
                [classes.hasHorses]: barnsWithHorses["24"]
              })}
            >
              <rect
                x="1712.5"
                y="605.6"
                transform="matrix(-1 -1.224647e-16 1.224647e-16 -1 3454.1528 1281.9586)"
                className={classes.barnPath}
                width="29.1"
                height="70.9"
              />
              <circle
                className={classes.circle}
                cx="1727.1"
                cy="641"
                r="16.7"
              />
              <text
                transform="matrix(1 0 0 1 1717.6855 645.9189)"
                className={clsx(classes.st15, classes.st16)}
              >
                24
              </text>
            </g>
            <g
              data-name="25"
              className={clsx(classes.barn, {
                [classes.hasHorses]: barnsWithHorses["25"]
              })}
            >
              <rect
                x="1733.4"
                y="671"
                transform="matrix(6.123234e-17 -1 1 6.123234e-17 1041.5234 2454.3892)"
                className={classes.barnPath}
                width="29.1"
                height="70.9"
              />
              <circle
                className={classes.circle}
                cx="1743.8"
                cy="706.4"
                r="16.7"
              />
              <text
                transform="matrix(1 0 0 1 1734.4934 711.3723)"
                className={clsx(classes.st15, classes.st16)}
              >
                25
              </text>
            </g>
            <g
              data-name="7"
              className={clsx(classes.barn, {
                [classes.hasHorses]: barnsWithHorses["7"]
              })}
            >
              <rect
                x="313.8"
                y="390"
                className={classes.barnPath}
                width="22.7"
                height="145"
              />
              <circle className={classes.circle} cx="325.1" cy="459" r="16.7" />
              <text
                transform="matrix(1 0 0 1 321.2072 463.9715)"
                className={clsx(classes.st15, classes.st16)}
              >
                7
              </text>
            </g>
            <g
              data-name="6"
              className={clsx(classes.barn, {
                [classes.hasHorses]: barnsWithHorses["6"]
              })}
            >
              <rect
                x="366.6"
                y="390"
                className={classes.barnPath}
                width="22.7"
                height="145"
              />
              <circle className={classes.circle} cx="378" cy="459" r="16.7" />
              <text
                transform="matrix(1 0 0 1 373.123 463.9715)"
                className={clsx(classes.st15, classes.st16)}
              >
                6
              </text>
            </g>
            <g
              data-name="5"
              className={clsx(classes.barn, {
                [classes.hasHorses]: barnsWithHorses["5"]
              })}
            >
              <rect
                x="419.5"
                y="390"
                className={classes.barnPath}
                width="22.7"
                height="145"
              />
              <circle className={classes.circle} cx="430.8" cy="459" r="16.7" />
              <text
                transform="matrix(1 0 0 1 426.0771 463.9715)"
                className={clsx(classes.st15, classes.st16)}
              >
                5
              </text>
            </g>
            <g
              data-name="2"
              className={clsx(classes.barn, {
                [classes.hasHorses]: barnsWithHorses["2"]
              })}
            >
              <rect
                x="313.8"
                y="557.2"
                className={classes.barnPath}
                width="22.7"
                height="145"
              />
              <circle className={classes.circle} cx="325.1" cy="626" r="16.7" />
              <text
                transform="matrix(1 0 0 1 320.6015 630.9749)"
                className={clsx(classes.st15, classes.st16)}
              >
                2
              </text>
            </g>
            <g
              data-name="1"
              className={clsx(classes.barn, {
                [classes.hasHorses]: barnsWithHorses["1"]
              })}
            >
              <rect
                x="260.9"
                y="557.2"
                className={classes.barnPath}
                width="22.7"
                height="145"
              />
              <circle className={classes.circle} cx="272.3" cy="626" r="16.7" />
              <text
                transform="matrix(1 0 0 1 269.4709 630.9749)"
                className={clsx(classes.st15, classes.st16)}
              >
                1
              </text>
            </g>
            <g
              id="q-on"
              data-name="Q"
              className={clsx(classes.barn, {
                [classes.hasHorses]: barnsWithHorses["q"]
              })}
            >
              <polygon
                className={classes.barnPath}
                points="290.6,423.2 257.5,423.2 257.5,494.9 266.2,494.9 266.2,534.2 280.5,534.2 280.5,494.9 290.6,494.9"
              />
              <circle className={classes.circle} cx="274.1" cy="459" r="16.7" />
              <text
                transform="matrix(1 0 0 1 267.9474 463.9715)"
                className={clsx(classes.st15, classes.st16)}
              >
                Q
              </text>
            </g>
            <g
              data-name="3"
              className={clsx(classes.barn, {
                [classes.hasHorses]: barnsWithHorses["3"]
              })}
            >
              <rect
                x="366.6"
                y="557.2"
                className={classes.barnPath}
                width="22.7"
                height="145"
              />
              <circle className={classes.circle} cx="378" cy="626" r="16.7" />
              <text
                transform="matrix(1 0 0 1 373.2487 630.9749)"
                className={clsx(classes.st15, classes.st16)}
              >
                3
              </text>
            </g>
            <g
              data-name="4"
              className={clsx(classes.barn, {
                [classes.hasHorses]: barnsWithHorses["4"]
              })}
            >
              <rect
                x="419.5"
                y="557.2"
                className={classes.barnPath}
                width="22.7"
                height="145"
              />
              <circle className={classes.circle} cx="430.8" cy="626" r="16.7" />
              <text
                transform="matrix(1 0 0 1 425.9509 630.9749)"
                className={clsx(classes.st15, classes.st16)}
              >
                4
              </text>
            </g>
            <g
              id="b-on"
              data-name="B"
              className={clsx(classes.barn, {
                [classes.hasHorses]: barnsWithHorses["b"]
              })}
            >
              <rect
                x="455.2"
                y="687.7"
                transform="matrix(-1.836970e-16 1 -1 -1.836970e-16 1205.6665 272.6117)"
                className={classes.barnPath}
                width="22.7"
                height="102.9"
              />
              <circle
                className={classes.circle}
                cx="464.2"
                cy="739.1"
                r="16.7"
              />
              <text
                transform="matrix(1 0 0 1 458.9458 744.0786)"
                className={clsx(classes.st15, classes.st16)}
              >
                B
              </text>
            </g>
            <g
              id="a-on"
              data-name="A"
              className={clsx(classes.barn, {
                [classes.hasHorses]: barnsWithHorses["a"]
              })}
            >
              <rect
                x="343.7"
                y="687.7"
                transform="matrix(-1.836970e-16 1 -1 -1.836970e-16 1094.1829 384.0953)"
                className={classes.barnPath}
                width="22.7"
                height="102.9"
              />
              <circle
                className={classes.circle}
                cx="353.2"
                cy="739.1"
                r="16.7"
              />
              <text
                transform="matrix(1 0 0 1 347.8449 744.0786)"
                className={clsx(classes.st15, classes.st16)}
              >
                A
              </text>
            </g>
            <g
              id="d-b-on"
              data-name="DB"
              className={clsx(classes.barn, {
                [classes.hasHorses]: barnsWithHorses["db"]
              })}
            >
              <rect
                x="232.8"
                y="784.8"
                transform="matrix(-1.836970e-16 1 -1 -1.836970e-16 1057.0803 568.8104)"
                className={classes.barnPath}
                width="22.7"
                height="56.3"
              />
              <circle
                className={classes.circle}
                cx="244.1"
                cy="812.9"
                r="16.7"
              />
              <text
                transform="matrix(1 0 0 1 238.8936 817.8849)"
                className={clsx(classes.st15, classes.st16)}
              >
                B
              </text>
            </g>
            <g
              id="d-c-on"
              data-name="DC"
              className={clsx(classes.barn, {
                [classes.hasHorses]: barnsWithHorses["dc"]
              })}
            >
              <rect
                x="232.8"
                y="868.4"
                transform="matrix(-1.836970e-16 1 -1 -1.836970e-16 1140.6931 652.4232)"
                className={classes.barnPath}
                width="22.7"
                height="56.3"
              />
              <circle
                className={classes.circle}
                cx="244.1"
                cy="896.6"
                r="16.7"
              />
              <text
                transform="matrix(1 0 0 1 238.4298 901.4976)"
                className={clsx(classes.st15, classes.st16)}
              >
                C
              </text>
            </g>
            <g
              id="d-a-on"
              data-name="DA"
              className={clsx(classes.barn, {
                [classes.hasHorses]: barnsWithHorses["da"]
              })}
            >
              <rect
                x="162.4"
                y="784.8"
                transform="matrix(-1.836970e-16 1 -1 -1.836970e-16 986.7429 639.1479)"
                className={classes.barnPath}
                width="22.7"
                height="56.3"
              />
              <circle
                className={classes.circle}
                cx="173.8"
                cy="812.9"
                r="16.7"
              />
              <text
                transform="matrix(1 0 0 1 168.485 817.8849)"
                className={clsx(classes.st15, classes.st16)}
              >
                A
              </text>
            </g>
          </g>
        </g>
      </svg>
    </div>
  );
};

export default React.memo(GulfstreamParkMap, mapPropsAreEqual);
